import React, { useEffect, useContext, useState, useRef } from "react";
import {
  OnBoardNotClear,
  TokenVerificationLoggedin,
  ScreenView
} from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import FullLoader from "../assets/images/full-page-loader.gif";
// import {
//   Col,
//   Row,
//   Input,
//   Space,
//   Select,
//   Radio,
//   Switch,
//   message,
//   Upload,
// } from "antd";
import copyIcon from '../assets/images/icons/copy.svg';
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import backButton from '../assets/images/back_button_arrow.svg';
import { notifycatch } from "../utils/toast";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import homeIcon from "../assets/images/icons/home.svg";
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
import uploadIcon from "../assets/images/icons/upload-cloud.svg";
import zoneInfoIcon from '../assets/images/icons/zone-info.svg';
import deleteIcon from '../assets/images/icons/trash.svg';
import zoomIcon from '../assets/images/icons/expand.svg';
import playIcon from '../assets/images/icons/play.svg';
import addVideoIcon from '../assets/images/icons/addVideoicon.svg';
import zoneIcon from '../assets/images/icons/zone.svg';
import NotIntig from '../assets/images/icons/not_inti.svg';
import IntegrationRrequest from '../assets/images/icons/integration_request_text.svg';
import { toast } from "react-toastify";

const ZoneCreate = ({ handlePageViewChange }) => {
  // const loadingContext = useContext(LoadingContext);

  useEffect(() => {
    const inputs = document.querySelectorAll('.ant-select-selection-search-input');

    inputs.forEach(input => {
      const handleInput = () => {
        const parent = input.closest('.ant-select-selection-search');
        if (input.value.length > 0) {
          parent.classList.add('searching');
        } else {
          parent.classList.remove('searching');
        }
      };

      input.addEventListener('input', handleInput);

      // Cleanup event listener on component unmount
      return () => {
        input.removeEventListener('input', handleInput);
      };
    });
  });


  useEffect(() => {
    // TokenVerificationLoggedin();
    // ScreenView();
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      let role = jwtDecode(token).role;
      let name = jwtDecode(token).p_name;
      if (role === "admin") {
        setPublisherName(name);
        setZoneName_prebid(name + "-Website-Banner");

        axios
          .get(configData.SERVER_URL + "ops/gamStatus", {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          })
          .then((response) => {
            setGamShow(response.data.data);
            setAniviewShow(response.data.aniview_data)
          })
          .catch((error) => { });

      }

      if (role === "mobops" || role === "sa") {
        axios
          .get(configData.SERVER_URL + "ops/getExchangeTypes", {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            setIntegrationTypeOptions_openrtb(response.data.data);
          })
          .catch((error) => { });
      }
      setRole(role);

    }
    // loadingContext.done();
  }, []);

  useEffect(() => {
    axios
      .get(configData.SERVER_URL + "zone/pubMinifiedList", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setPublisherList(response.data.data);
      })
      .catch((error) => { });





  }, []);

  ////////////////////////////////////////////role and publisher list/publisher for not admin states  and form view////////////////////////////////

  function resetFormView() {
    setPublisherName("");
    setPublisherIsRequiredError(false);
    reset_prebid()
    setFormType("Prebid");
    setSelectedPublisher("");
    setButtonProcessing(false)

  }

  const [role, setRole] = useState("admin");
  const [publisherName, setPublisherName] = useState("");
  const [selectedPublisher, setSelectedPublisher] = useState("");
  const [publisherIsRequiredError, setPublisherIsRequiredError] =
    useState(false);
  const [publisherList, setPublisherList] = useState([]);
  const [buttonProcessing, setButtonProcessing] = useState(false);

  function onChangePublisher(event) {

    reset_prebid()

    const selectedPublisher = publisherList?.find(
      (publisher) => publisher.value === event
    );

    const selectedGam = selectedPublisher ? selectedPublisher.gam_check : false;
    const selectedAniview = selectedPublisher ? selectedPublisher.aniview_check : false;
    setGamShow(selectedGam)
    setAniviewShow(selectedAniview)


    setPublisherIsRequiredError(false);
    setSelectedPublisher(event);
    setPublisherName(event.split("-").slice(1).join("-"));

    // if (formType === "Prebid" ) {
    setZoneNameIsRequiredError_prebid(false);
    setZoneName_prebid(
      event.split("-").slice(1).join("-") +
      "-" +
      platformType_prebid +
      "-" +
      formatType_prebid?.join(', ')
    );
    // } 
    // else if (formType === "Open RTB") {
    //   setZoneNameIsRequiredError_openrtb(false);
    //   setZoneName_openrtb(
    //     event.split("-").slice(1).join("-") +
    //     "-" +
    //     platformType_openrtb +
    //     "-" +
    //     formatType_openrtb
    //   );
    // }
    // else if (formType === "Vast Zone") {
    //   setZoneNameIsRequiredError_vastzone(false);
    //   setZoneName_vastzone(
    //     event.split("-").slice(1).join("-") +
    //     "-" +
    //     platformType_openrtb
    //   );
    // }
    // else if (formType === "Player Tag") {
    //   setChannelNameIsRequiredError_playertag(false);
    //   setChannelName_playertag(
    //     event.split("-").slice(1).join("-") + "_" + platformType_playertag + "_" + playerMode_playertag?.toLowerCase()
    //   );
    // }
    // else if (formType === "GAM Tag") {
    //   setAccountNameIsRequiredError_gamtag(false);
    //   setAccountName_gamtag(
    //     event.split("-").slice(1).join("-") + "_MI"
    //   );
    // }

    setFormType("Prebid")

  }

  const [formType, setFormType] = useState("Prebid");


  const handleButtonClick = () => {

    setFormTypeOption(prevState =>
      prevState.map(option => {
        if (option.value === "GAM Tag") {
          return {
            ...option,
            label: (
              <div className="add_newbtn_design2 d-flex justify-content-between">
                <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
                <button
                  className="w_120_d2 btn btn_primary w_fit_content loader text-capitalize"
                >
                  <span>Request Activation</span>
                  <img
                    src={loaderIcon}
                    alt="USP"
                    className="loader_icon"
                  />
                </button>
              </div>
            )
          };
        }
        return option;
      })
    );

    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp")
      axios
        .post(configData.SERVER_URL + "zone/reqGAM", {}, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          notifysuccess("Request Sent Successfully");
          setFormTypeOption(prevState =>
            prevState.map(option => {
              if (option.value === "GAM Tag") {
                return {
                  ...option,
                  label: (
                    <div className="add_newbtn_design2 d-flex justify-content-between">
                      <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
                      <p> <span><img src={IntegrationRrequest} alt="" /></span></p>
                    </div>
                  )
                };
              }
              return option;
            })
          );
        })
        .catch((error) => {
          notifyfailure("Failure in raising request");
          setFormTypeOption(prevState =>
            prevState.map(option => {
              if (option.value === "GAM Tag") {
                return {
                  ...option,
                  label: (
                    <div className="add_newbtn_design2 d-flex justify-content-between">
                      <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
                      <button className="btn btn_primary w_fit_content text-capitalize" onClick={handleButtonClick}> Request Activation </button>
                    </div>
                  )
                };
              }
              return option;
            })
          );
        });
    }


  };

  const [gamShow, setGamShow] = useState(null)
  const [aniviewShow, setAniviewShow] = useState(null)

  const [formTypeOption, setFormTypeOption] = useState([
    { label: "Prebid", value: "Prebid" },
    { label: "Open RTB", value: "Open RTB" },
    { label: "Vast (ADK)", value: "Vast Zone" },
    {
      label: <div className="add_newbtn_design2 d-flex justify-content-between">
        <p> Vast (Aniview) <span><img src={NotIntig} alt="" /></span></p>
      </div>, value: "vast_aniview", disabled: true
    },
    {
      label: <div className="add_newbtn_design2 d-flex justify-content-between">
        <p> Player Tag (Instream) <span><img src={NotIntig} alt="" /></span></p>
      </div>, value: "Player Tag", disabled: true
    },
    {
      label: <div className="add_newbtn_design2 d-flex justify-content-between">
        <p> Player Tag (Outstream) <span><img src={NotIntig} alt="" /></span></p>
      </div>, value: "tag_outstream", disabled: true
    },
    {
      label:
        <div className="add_newbtn_design2 d-flex justify-content-between">
          <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
        </div>
      , value: "GAM Tag", disabled: true
    },
  ]);


  useEffect(() => {

    const updatedOptions = [
      { label: "Prebid", value: "Prebid" },
      { label: "Open RTB", value: "Open RTB" },
      { label: "Vast (ADK)", value: "Vast Zone" },
      {
        label: aniviewShow ? "Vast (Aniview)" :
          <div className="add_newbtn_design2 d-flex justify-content-between">
            <p> Vast (Aniview) <span><img src={NotIntig} alt="" /></span></p>
          </div>, value: "vast_aniview", disabled: aniviewShow ? false : true
      },
      {
        label: aniviewShow ? "Player Tag (Instream)" :
          <div className="add_newbtn_design2 d-flex justify-content-between">
            <p> Player Tag (Instream)<span><img src={NotIntig} alt="" /></span></p>
          </div>, value: "Player Tag", disabled: aniviewShow ? false : true
      },
      {
        label: aniviewShow ? "Player Tag (Outstream)" :
          <div className="add_newbtn_design2 d-flex justify-content-between">
            <p> Player Tag (Outstream)<span><img src={NotIntig} alt="" /></span></p>
          </div>, value: "tag_outstream", disabled: aniviewShow ? false : true
      },
      {
        label: gamShow ? "GAM Tag" : publisherName === "" ?
          <div className="add_newbtn_design2 d-flex justify-content-between">
            <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
          </div> :
          role !== "admin" ?

            <div className="add_newbtn_design2 d-flex justify-content-between">
              <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
            </div> :
            <div className="add_newbtn_design2 d-flex justify-content-between">
              <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
              <button className="btn btn_primary w_fit_content text-capitalize"
                onClick={handleButtonClick}
              > Request Activation </button>
            </div>
        ,
        value: "GAM Tag", disabled: gamShow ? false : true
      },
    ];

    setFormTypeOption(updatedOptions);
  }, [gamShow, aniviewShow]);


  function onChangeFormType(event) {
    setFormType(event);

    if (event === "Prebid") {
      reset_prebid();
      if (publisherName !== "") {
        setZoneName_prebid(
          publisherName + "-" + platformType_prebid + "-" + formatType_prebid?.join(",")
        );
      }
    } else if (event === "Open RTB") {
      reset_openrtb();
      if (publisherName !== "") {
        setZoneName_openrtb(
          publisherName + "-" + platformType_openrtb + "-" + formatType_openrtb?.join(",")
        );
      }
    } else if (event === "Vast Zone") {
      reset_vastzone();
      if (publisherName !== "") {
        setZoneName_vastzone(publisherName + "-" + platformType_vastzone);
      }
    }

    else if (event === "vast_aniview") {
      reset_vast_aniview();
      if (publisherName !== "") {
        setChannelName_vast_aniview(
          publisherName + "_" + platformType_vast_aniview
        );
      }
    }


    else if (event === "Player Tag" || event === "tag_outstream") {
      reset_playertag();
      if (event === "tag_outstream") {
        setFloatingPosition_playertag("default")
      }
      if (publisherName !== "") {
        setChannelName_playertag(
          publisherName + "_" + platformType_playertag + "_" + playerMode_playertag?.toLowerCase()
        );
      }
    }

    else if (event === "GAM Tag") {
      reset_gamtag();
      if (publisherName !== "") {
        setAccountName_gamtag(
          publisherName + "_MI"
        );
      }
    }
  }

  /////////////////////////////////////////////////////prebaid code /////////////////////////////////////////
  const [platformType_prebid, setPlatformType_prebid] = useState("Website");
  const [formatType_prebid, setFormatType_prebid] = useState(["Banner"]);
  const [formatTypeIsRequiredError_prebid, setFormatTypeIsRequiredError_prebid] = useState(false);
  const [integrationType_prebid, setIntegrationType_prebid] =
    useState("OPEN_RTB");
  const [integrationTypeOptions_prebid, setIntegrationTypeOptions_prebid] =
    useState([
      { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
      { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
      { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
    ]);
  const [bannerCheckbox_prebid, setBannerCheckbox_prebid] = useState(null);
  const [bannerCheckboxIsRequiredError_prebid, setBannerCheckboxIsRequiredError_prebid] = useState(false);

  const [zoneActiveCheckbox_prebid, setZoneActiveCheckbox_prebid] =
    useState(true);
  const [zoneName_prebid, setZoneName_prebid] = useState("");
  const [zoneNameIsRequiredError_prebid, setZoneNameIsRequiredError_prebid] =
    useState(false);
  const [request_prebid, setRequest_prebid] = useState("");
  // const [requestIsRequiredError_prebid, setRequestIsRequiredError_prebid] =
  //   useState(false);
  const [requestValueError_prebid, setRequestValueError_prebid] =
    useState(false);
  const [impression_prebid, setImpression_prebid] = useState("");
  // const [
  //   impressionIsRequiredError_prebid,
  //   setImpressionIsRequiredError_prebid,
  // ] = useState(false);
  const [impressionValueError_prebid, setImpressionValueError_prebid] =
    useState(false);

  function reset_prebid() {
    setPlatformType_prebid("Website");
    setFormatType_prebid(["Banner"]);
    setFormatTypeIsRequiredError_prebid(false)
    // setFormatTypeOptions_prebid([
    //   { label: "Banner", value: "Banner" },
    //   { label: "Video", value: "Video" },
    //   { label: "Native", value: "Native" },
    // ]);
    setIntegrationType_prebid("OPEN_RTB");
    setIntegrationTypeOptions_prebid([
      { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
      { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
      { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
    ]);
    setBannerCheckbox_prebid(null);
    setBannerCheckboxIsRequiredError_prebid(false);

    setZoneActiveCheckbox_prebid(true);
    setZoneName_prebid("");
    setZoneNameIsRequiredError_prebid(false);
    setRequest_prebid("");
    //setRequestIsRequiredError_prebid(false);
    setRequestValueError_prebid(false);
    setImpression_prebid("");
    // setImpressionIsRequiredError_prebid(false);
    setImpressionValueError_prebid(false);
  }

  function onChangePlatformType_prebid(event) {
    setPlatformType_prebid(event.target.value);
    if (publisherName !== "") {
      setZoneName_prebid(
        publisherName + "-" + event.target.value + "-" + formatType_prebid?.join(",")
      );
    }
    setZoneNameIsRequiredError_prebid(false);
  }

  function onChangeFormatType_prebid(event) {

    if (event?.length === 0) {
      setFormatTypeIsRequiredError_prebid(true)
    }
    else {
      setFormatTypeIsRequiredError_prebid(false)
    }


    if (!event?.includes("Banner")) {
      setBannerCheckbox_prebid(null);
      setBannerCheckboxIsRequiredError_prebid(false)
    }
    setFormatType_prebid(event);
    if (publisherName !== "") {
      setZoneName_prebid(
        publisherName + "-" + platformType_prebid + "-" + event?.join(",")
      );
    }
    setZoneNameIsRequiredError_prebid(false);
  }

  function onChangeIntegrationType_prebid(event) {
    setIntegrationType_prebid(event);
  }

  function onChangeBannerCheckbox_prebid(event) {
    setBannerCheckboxIsRequiredError_prebid(false)
    setBannerCheckbox_prebid(event.target.value);
  }

  function onChangeZoneActiveCheckbox_prebid(event) {
    setZoneActiveCheckbox_prebid(event.target.checked);
  }

  function onChangeZoneName_prebid(event) {
    setZoneNameIsRequiredError_prebid(false);
    setZoneName_prebid(event.target.value);
  }

  function onBlurZoneName_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setZoneNameIsRequiredError_prebid(true);
    }
    setZoneName_prebid(event.target.value.trim());
  }

  function onChangeRequest_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_prebid(false);
      setRequest_prebid(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setRequest_prebid(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setRequestValueError_prebid(false);
        } else {
          setRequestValueError_prebid(true);
        }
      }
    }
  }

  function onBlurRequest_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_prebid(false);
      // setRequestIsRequiredError_prebid(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setRequestValueError_prebid(false);
      } else {
        // setRequestIsRequiredError_prebid(false);
        setRequestValueError_prebid(true);
      }
    }
    setRequest_prebid(event.target.value.trim());
  }

  function onChangeImpression_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_prebid(false);
      setImpression_prebid(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setImpression_prebid(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setImpressionValueError_prebid(false);
        } else {
          setImpressionValueError_prebid(true);
        }
      }
    }
  }

  function onBlurImpression_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_prebid(false);
      // setImpressionIsRequiredError_prebid(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setImpressionValueError_prebid(false);
      } else {
        // setImpressionIsRequiredError_prebid(false);
        setImpressionValueError_prebid(true);
      }
    }
    setImpression_prebid(event.target.value.trim());
  }

  ///////////////////////////////////////////////////open rtb code ///////////////////////////////////////////
  const [platformType_openrtb, setPlatformType_openrtb] = useState("Website");
  const [formatType_openrtb, setFormatType_openrtb] = useState(["Banner"]);
  const [formatTypeIsRequiredError_openrtb, setFormatTypeIsRequiredError_openrtb] = useState(false);
  const [integrationType_openrtb, setIntegrationType_openrtb] =
    useState("OPEN_RTB");
  const [integrationTypeOptions_openrtb, setIntegrationTypeOptions_openrtb] =
    useState([
      { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
      { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
      { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
    ]);

  const [bannerCheckbox_openrtb, setBannerCheckbox_openrtb] = useState(null);
  const [bannerCheckboxIsRequiredError_openrtb, setBannerCheckboxIsRequiredError_openrtb] = useState(false);

  const [zoneActiveCheckbox_openrtb, setZoneActiveCheckbox_openrtb] =
    useState(true);
  const [zoneName_openrtb, setZoneName_openrtb] = useState("");
  const [zoneNameIsRequiredError_openrtb, setZoneNameIsRequiredError_openrtb] =
    useState(false);
  const [request_openrtb, setRequest_openrtb] = useState("");
  // const [requestIsRequiredError_openrtb, setRequestIsRequiredError_openrtb] =
  //   useState(false);
  const [requestValueError_openrtb, setRequestValueError_openrtb] =
    useState(false);
  const [impression_openrtb, setImpression_openrtb] = useState("");
  // const [
  //   impressionIsRequiredError_openrtb,
  //   setImpressionIsRequiredError_openrtb,
  // ] = useState(false);
  const [impressionValueError_openrtb, setImpressionValueError_openrtb] =
    useState(false);

  function reset_openrtb() {
    setPlatformType_openrtb("Website");
    setFormatType_openrtb(["Banner"]);
    setFormatTypeIsRequiredError_openrtb(false)

    setIntegrationType_openrtb("OPEN_RTB");
    // setIntegrationTypeOptions_openrtb([
    //   { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
    //   { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
    //   { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
    // ]);
    setBannerCheckbox_openrtb(null);
    setBannerCheckboxIsRequiredError_openrtb(false);
    setZoneActiveCheckbox_openrtb(true);
    setZoneName_openrtb("");
    setZoneNameIsRequiredError_openrtb(false);
    setRequest_openrtb("");
    //setRequestIsRequiredError_openrtb(false);
    setRequestValueError_openrtb(false);
    setImpression_openrtb("");
    // setImpressionIsRequiredError_openrtb(false);
    setImpressionValueError_openrtb(false);
  }

  function onChangePlatformType_openrtb(event) {

    if (event.target.value === "CTV") {
      setBannerCheckbox_openrtb(null)
      setBannerCheckboxIsRequiredError_openrtb(false)
    }

    setPlatformType_openrtb(event.target.value);
    if (publisherName !== "") {
      if (event.target.value === "CTV") {
        setZoneName_openrtb(
          publisherName + "-" + event.target.value + "-" + "Video"
        );
      }
      else {
        setZoneName_openrtb(
          publisherName + "-" + event.target.value + "-" + formatType_openrtb?.join(",")
        );
      }

    }
    setZoneNameIsRequiredError_openrtb(false);
  }

  function onChangeFormatType_openrtb(event) {
    if (event?.length === 0) {
      setFormatTypeIsRequiredError_openrtb(true)
    }
    else {
      setFormatTypeIsRequiredError_openrtb(false)
    }


    if (!event?.includes("Banner")) {
      setBannerCheckbox_openrtb(null);
      setBannerCheckboxIsRequiredError_openrtb(false)
    }
    setFormatType_openrtb(event);
    if (publisherName !== "") {
      setZoneName_openrtb(
        publisherName + "-" + platformType_openrtb + "-" + event?.join(",")
      );
    }
    setZoneNameIsRequiredError_openrtb(false);
  }

  function onChangeIntegrationType_openrtb(event) {
    setIntegrationType_openrtb(event);
  }

  function onChangeBannerCheckbox_openrtb(event) {
    setBannerCheckboxIsRequiredError_openrtb(false)
    setBannerCheckbox_openrtb(event.target.value);
  }

  function onChangeZoneActiveCheckbox_openrtb(event) {
    setZoneActiveCheckbox_openrtb(event.target.checked);
  }

  function onChangeZoneName_openrtb(event) {
    setZoneNameIsRequiredError_openrtb(false);
    setZoneName_openrtb(event.target.value);
  }

  function onBlurZoneName_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setZoneNameIsRequiredError_openrtb(true);
    }
    setZoneName_openrtb(event.target.value.trim());
  }

  function onChangeRequest_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_openrtb(false);
      setRequest_openrtb(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setRequest_openrtb(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setRequestValueError_openrtb(false);
        } else {
          setRequestValueError_openrtb(true);
        }
      }
    }
  }

  function onBlurRequest_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_openrtb(false);
      // setRequestIsRequiredError_openrtb(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setRequestValueError_openrtb(false);
      } else {
        // setRequestIsRequiredError_openrtb(false);
        setRequestValueError_openrtb(true);
      }
    }
    setRequest_openrtb(event.target.value.trim());
  }

  function onChangeImpression_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_openrtb(false);
      setImpression_openrtb(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setImpression_openrtb(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setImpressionValueError_openrtb(false);
        } else {
          setImpressionValueError_openrtb(true);
        }
      }
    }
  }

  function onBlurImpression_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_openrtb(false);
      // setImpressionIsRequiredError_openrtb(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setImpressionValueError_openrtb(false);
      } else {
        // setImpressionIsRequiredError_openrtb(false);
        setImpressionValueError_openrtb(true);
      }
    }
    setImpression_openrtb(event.target.value.trim());
  }

  ///////////////////////////////////////////////////vast zone code ///////////////////////////////////////////

  const [platformType_vastzone, setPlatformType_vastzone] = useState("Website");

  const [streamPosition_vastzone, setStreamPosition_vastzone] = useState("Outstream");
  const [streamPositionOptions_vastzone, setStreamPositionOptions_vastzone] = useState([
    { label: "Outstream", value: "Outstream" },
    { label: "Instream", value: "Instream" },
  ]);

  const [zoneActiveCheckbox_vastzone, setZoneActiveCheckbox_vastzone] =
    useState(true);
  const [zoneName_vastzone, setZoneName_vastzone] = useState("");
  const [zoneNameIsRequiredError_vastzone, setZoneNameIsRequiredError_vastzone] =
    useState(false);


  const [revenueType_vastzone, setRevenueType_vastzone] = useState("Fixed_Price");
  const [revenueTypeOptions_vastzone, setRevenueTypeOptions_vastzone] = useState([
    { label: "Fixed Price", value: "Fixed_Price" },
    { label: "Revshare", value: "Revshare" },
  ]);

  const [eCpm_vastzone, setECpm_vastzone] = useState("");
  const [eCpmIsRequiredError_vastzone, setECpmIsRequiredError_vastzone] = useState("");
  const [eCpmValidError_vastzone, setECpmValidError_vastzone] = useState("");


  const [revSharePercent_vastzone, setRevSharePercent_vastzone] = useState("");
  const [revSharePercentIsRequiredError_vastzone, setRevSharePercentIsRequiredError_vastzone] = useState("");
  const [revSharePercentValidError_vastzone, setRevSharePercentValidError_vastzone] = useState("");



  const [request_vastzone, setRequest_vastzone] = useState("");
  // const [requestIsRequiredError_vastzone, setRequestIsRequiredError_vastzone] =
  //   useState(false);
  const [requestValueError_vastzone, setRequestValueError_vastzone] =
    useState(false);
  const [impression_vastzone, setImpression_vastzone] = useState("");
  // const [
  //   impressionIsRequiredError_vastzone,
  //   setImpressionIsRequiredError_vastzone,
  // ] = useState(false);
  const [impressionValueError_vastzone, setImpressionValueError_vastzone] =
    useState(false);

  function reset_vastzone() {
    setPlatformType_vastzone("Website");
    setStreamPosition_vastzone("Outstream");
    setStreamPositionOptions_vastzone([
      { label: "Outstream", value: "Outstream" },
      { label: "Instream", value: "Instream" },
    ]);

    setZoneActiveCheckbox_vastzone(true);
    setZoneName_vastzone("");
    setZoneNameIsRequiredError_vastzone(false);
    setRevenueType_vastzone("Fixed_Price");
    setRevenueTypeOptions_vastzone([
      { label: "Fixed Price", value: "Fixed_Price" },
      { label: "Revshare", value: "Revshare" },
    ]);
    setECpm_vastzone("");
    setECpmIsRequiredError_vastzone("");
    setECpmValidError_vastzone("");
    setRevSharePercent_vastzone("");
    setRevSharePercentIsRequiredError_vastzone("");
    setRevSharePercentValidError_vastzone("");
    setRequest_vastzone("");
    // setRequestIsRequiredError_vastzone(false);
    setRequestValueError_vastzone(false);
    setImpression_vastzone("");
    // setImpressionIsRequiredError_vastzone(false);
    setImpressionValueError_vastzone(false);
  }

  function onChangePlatformType_vastzone(event) {
    setPlatformType_vastzone(event.target.value);
    if (publisherName !== "") {
      setZoneName_vastzone(
        publisherName + "-" + event.target.value
      );
    }
    setZoneNameIsRequiredError_vastzone(false);
  }

  function onChangeStreamPosition_vastzone(event) {
    setStreamPosition_vastzone(event);
  }



  function onChangeZoneActiveCheckbox_vastzone(event) {
    setZoneActiveCheckbox_vastzone(event.target.checked);
  }

  function onChangeZoneName_vastzone(event) {
    setZoneNameIsRequiredError_vastzone(false);
    setZoneName_vastzone(event.target.value);
  }

  function onBlurZoneName_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setZoneNameIsRequiredError_vastzone(true);
    }
    setZoneName_vastzone(event.target.value.trim());
  }

  function onChangeRevenueType_vastzone(event) {
    setRevenueType_vastzone(event);
    setECpm_vastzone("");
    setECpmIsRequiredError_vastzone(false);
    setECpmValidError_vastzone(false);
    setRevSharePercent_vastzone("");
    setRevSharePercentIsRequiredError_vastzone(false);
    setRevSharePercentValidError_vastzone(false);
  }


  function onChangeECpm_vastzone(event) {
    setECpmIsRequiredError_vastzone(false);
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setECpm_vastzone(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vastzone(false)
      }
      else {
        setECpmValidError_vastzone(true)
      }
    }
  }

  function onBlurECpm_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setECpmValidError_vastzone(false);
      setECpmIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vastzone(false);
      } else {
        setECpmIsRequiredError_vastzone(false);
        setECpmValidError_vastzone(true);
      }
    }
    setECpm_vastzone(event.target.value.trim());
  }

  function onChangeRevSharePercent_vastzone(event) {
    setRevSharePercentIsRequiredError_vastzone(false);
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setRevSharePercent_vastzone(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
        setRevSharePercentValidError_vastzone(false)
      }
      else {
        setRevSharePercentValidError_vastzone(true)
      }
    }
  }

  function onBlurRevSharePercent_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setRevSharePercentValidError_vastzone(false);
      setRevSharePercentIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
        setRevSharePercentValidError_vastzone(false);
      } else {
        setRevSharePercentIsRequiredError_vastzone(false);
        setRevSharePercentValidError_vastzone(true);
      }
    }
    setRevSharePercent_vastzone(event.target.value.trim());
  }


  function onChangeRequest_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_vastzone(false);
      setRequest_vastzone(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setRequest_vastzone(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setRequestValueError_vastzone(false);
        } else {
          setRequestValueError_vastzone(true);
        }
      }
    }
  }

  function onBlurRequest_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_vastzone(false);
      // setRequestIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setRequestValueError_vastzone(false);
      } else {
        // setRequestIsRequiredError_vastzone(false);
        setRequestValueError_vastzone(true);
      }
    }
    setRequest_vastzone(event.target.value.trim());
  }

  function onChangeImpression_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_vastzone(false);
      setImpression_vastzone(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setImpression_vastzone(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setImpressionValueError_vastzone(false);
        } else {
          setImpressionValueError_vastzone(true);
        }
      }
    }
  }

  function onBlurImpression_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_vastzone(false);
      // setImpressionIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setImpressionValueError_vastzone(false);
      } else {
        // setImpressionIsRequiredError_vastzone(false);
        setImpressionValueError_vastzone(true);
      }
    }
    setImpression_vastzone(event.target.value.trim());
  }

  ///////////////////////////////////////////////////vast aniview tag code ///////////////////////////////////////////

  const [platformType_vast_aniview, setPlatformType_vast_aniview] = useState("Website");

  const [channelName_vast_aniview, setChannelName_vast_aniview] = useState("");
  const [channelNameIsRequiredError_vast_aniview, setChannelNameIsRequiredError_vast_aniview] =
    useState(false);

  const [eCpm_vast_aniview, setECpm_vast_aniview] = useState("");
  const [eCpmIsRequiredError_vast_aniview, setECpmIsRequiredError_vast_aniview] = useState(false);
  const [eCpmValidError_vast_aniview, setECpmValidError_vast_aniview] = useState(false);

  function reset_vast_aniview() {
    setPlatformType_vast_aniview("Website");
    setChannelName_vast_aniview("");
    setChannelNameIsRequiredError_vast_aniview(false);
    setECpm_vast_aniview("");
    setECpmIsRequiredError_vast_aniview(false);
    setECpmValidError_vast_aniview(false);
  }

  function onChangePlatformType_vast_aniview(event) {
    setPlatformType_vast_aniview(event.target.value);

    if (publisherName !== "") {
      setChannelName_vast_aniview(
        publisherName + "_" + event.target.value
      );
    }
    setChannelNameIsRequiredError_vast_aniview(false);
  }

  function onChangeChannelName_vast_aniview(event) {
    setChannelNameIsRequiredError_vast_aniview(false);
    setChannelName_vast_aniview(event.target.value);
  }

  function onBlurChannelName_vast_aniview(event) {
    if (event.target.value.trim().length === 0) {
      setChannelNameIsRequiredError_vast_aniview(true);
    }
    setChannelName_vast_aniview(event.target.value.trim());
  }



  function onChangeECpm_vast_aniview(event) {
    setECpmIsRequiredError_vast_aniview(false);
    if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
      setECpm_vast_aniview(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vast_aniview(false)
      }
      else {
        setECpmValidError_vast_aniview(true)
      }
    }
  }

  function onBlurECpm_vast_aniview(event) {
    if (event.target.value.trim().length === 0) {
      setECpmValidError_vast_aniview(false);
      setECpmIsRequiredError_vast_aniview(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vast_aniview(false);
      } else {
        setECpmIsRequiredError_vast_aniview(false);
        setECpmValidError_vast_aniview(true);
      }
    }
    setECpm_vast_aniview(event.target.value.trim());
  }

  ///////////////////////////////////////////////////player tag code ///////////////////////////////////////////

  const [platformType_playertag, setPlatformType_playertag] = useState("Website");

  const [playerMode_playertag, setPlayerMode_playertag] = useState("articleVideo");
  const [playerModeOptions_playertag, setPlayerModeOptions_playertag] = useState([
    { label: "Article Video", value: "articleVideo" },
    { label: "Banner Video", value: "bannerVideo" },
  ]);

  const [floatingPosition_playertag, setFloatingPosition_playertag] = useState("bottomRight");
  const [floatingPositionOptions_playertag, setFloatingPositionOptions_playertag] = useState([
    { label: "Bottom Right", value: "bottomRight" },
    { label: "Bottom Left", value: "bottomLeft" },
    { label: "Top Right", value: "topRight" },
    { label: "Top Left", value: "topLeft" },
    { label: "Top Center", value: "topCenter" },
    { label: "Bottom Center", value: "bottomCenter" },
  ]);
  const [floatingPositionOptions_tag_outstream, setFloatingPositionOptions_tag_outstream] = useState([
    { label: "Default", value: "default" },
    { label: "Top Right", value: "topRight" },
    { label: "Top Left", value: "topLeft" },
  ]);

  const [channelName_playertag, setChannelName_playertag] = useState("");
  const [channelNameIsRequiredError_playertag, setChannelNameIsRequiredError_playertag] =
    useState(false);


  const [eCpm_playertag, setECpm_playertag] = useState("");
  const [eCpmIsRequiredError_playertag, setECpmIsRequiredError_playertag] = useState("");
  const [eCpmValidError_playertag, setECpmValidError_playertag] = useState("");

  function reset_playertag() {

    setPlatformType_playertag("Website");

    setPlayerMode_playertag("articleVideo");
    setPlayerModeOptions_playertag([
      { label: "Article Video", value: "articleVideo" },
      { label: "Banner Video", value: "bannerVideo" },
    ]);

    setFloatingPosition_playertag("bottomRight");
    setChannelName_playertag("");
    setChannelNameIsRequiredError_playertag(false);
    setECpm_playertag("");
    setECpmIsRequiredError_playertag("");
    setECpmValidError_playertag("");

    setMainTableVideo_playertag([])

  }



  function onChangePlatformType_playertag(event) {
    setPlatformType_playertag(event.target.value);

    if (publisherName !== "") {
      setChannelName_playertag(
        publisherName + "_" + event.target.value + "_" + playerMode_playertag?.toLowerCase()
      );
    }
    setChannelNameIsRequiredError_playertag(false);
  }


  function onChangePlayerMode_playertag(event) {
    setPlayerMode_playertag(event);
    // if (event === "articleVideo") {
    //   setFloatingPosition_playertag("bottomRight")
    // }

    if (publisherName !== "") {
      setChannelName_playertag(
        publisherName + "_" + platformType_playertag + "_" + event?.toLowerCase()
      );
    }
    setChannelNameIsRequiredError_playertag(false);
  }

  function onChangeFloatingPosition_playertag(event) {
    setFloatingPosition_playertag(event);
  }

  function onChangeChannelName_playertag(event) {
    setChannelNameIsRequiredError_playertag(false);
    setChannelName_playertag(event.target.value);
  }

  function onBlurChannelName_playertag(event) {
    if (event.target.value.trim().length === 0) {
      setChannelNameIsRequiredError_playertag(true);
    }
    setChannelName_playertag(event.target.value.trim());
  }



  function onChangeECpm_playertag(event) {
    setECpmIsRequiredError_playertag(false);
    if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
      setECpm_playertag(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_playertag(false)
      }
      else {
        setECpmValidError_playertag(true)
      }
    }
  }

  function onBlurECpm_playertag(event) {
    if (event.target.value.trim().length === 0) {
      setECpmValidError_playertag(false);
      setECpmIsRequiredError_playertag(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_playertag(false);
      } else {
        setECpmIsRequiredError_playertag(false);
        setECpmValidError_playertag(true);
      }
    }
    setECpm_playertag(event.target.value.trim());
  }



  // ///////////////////////////////Player tag modal related code ////////////////////////////////

  const [mainTableVideo_playertag, setMainTableVideo_playertag] = useState([])

  const [tempTableUploadVideo_playertag, setTempTableUploadVideo_playertag] = useState([])
  const [tempTableLinkVideo_playertag, setTempTableLinkVideo_playertag] = useState([])


  const [tempTableSuggestedMainVideo_playertag, setTempTableSuggestedMainVideo_playertag] = useState([])
  const [tempTableSuggestedMainVideoChecked_playertag, setTempTableSuggestedMainVideoChecked_playertag] = useState([])

  const [tempTableSuggestedSubVideo_playertag, setTempTableSuggestedSubVideo_playertag] = useState([])
  const [tempTableSuggestedSubVideoChecked_playertag, setTempTableSuggestedSubVideoChecked_playertag] = useState([])

  const [modalVideoLinkInput, setModalVideoLinkInput] = useState('');
  const [modalVideoLinkInputError, setModalVideoLinkInputError] = useState(false);
  const [modalVideoLinkInputLoader, setModalVideoLinkInputLoader] = useState(false);
  const [modalVideoLinkInputErrorMsg, setModalVideoLinkInputErrorMsg] = useState("");


  const [isModalVisibleVideo, setIsModalVisibleVideo] = useState(false)
  const videoRef1 = useRef([]);
  const videoRef2 = useRef([]);
  const videoRef3 = useRef([]);
  const videoRef4 = useRef([]);
  const videoRef5 = useRef([]);

  const [activeKeyVideoTab, setActiveKeyVideoTab] = useState('1');
  const [activeKeyVideoTabName, setActiveKeyVideoTabName] = useState('Suggested');


  const [dragging, setDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);

    let count = 0;

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (droppedFiles.length > 0) {
      let tempMediaKit = [...tempTableUploadVideo_playertag];
      for (let file of droppedFiles) {

        if (file.size / (1024 * 1024) < 100 && (file.type.includes("video"))) {

          tempMediaKit.push({
            aniviewId: "",
            data: file,
            url: URL.createObjectURL(file),
            filename: file.name,
            size: file.size
          });
        }
        else {
          count++;

        }
      }
      setTempTableUploadVideo_playertag(tempMediaKit);
      const fileInput00 = document.getElementById("file001");
      fileInput00.value = "";
      if (count !== 0) {
        notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && video format`)
      }
    }
  };

  function onChangeMediakit(e) {
    let count = 0;

    if (e.target.files.length > 0) {
      let tempMediaKit = [...tempTableUploadVideo_playertag];

      for (let file of e.target.files) {

        if (file.size / (1024 * 1024) < 100 && (file.type.includes("video"))) {
          tempMediaKit.push({
            aniviewId: "",
            data: file,
            url: URL.createObjectURL(file),
            filename: file.name,
            size: file.size
          });
        }
        else {
          count++;

        }
      }

      setTempTableUploadVideo_playertag(tempMediaKit);
      const fileInput00 = document.getElementById("file001");
      fileInput00.value = "";

      if (count !== 0) {
        notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && video format`)
      }

      //   } else {
      //     setMediakit({
      //       data: "",
      //       preview: "",
      //     });
      //     setMediakitFilename("");
      //     notifyfailure("File Size Should be less than 100 MB");
      //   }
    }
  }


  const handleMouseEnter = (e) => {
    try {
      // Check if the media element is currently paused before playing
      if (e?.target?.paused) {
        e.target.play()
          .catch(error => {
            // Handle potential play errors (e.g., autoplay policy)
            console.error('Failed to start playing:', error);
          });
      }
    } catch (error) {
      // Handle any other potential errors
      console.error('An error occurred:', error);
    }
  };

  const handleMouseLeave = (e) => {
    try {
      // Check if the media element is currently paused before playing
      if (e?.target?.play) {
        e.target.pause()
          .catch(error => {
            // Handle potential play errors (e.g., autoplay policy)
            console.error('Failed to start playing:', error);
          });
      }
    } catch (error) {
      // Handle any other potential errors
      console.error('An error occurred:', error);
    }
  };


  const handleFullscreen1 = (index) => {
    const videoElement = videoRef1.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen2 = (index) => {
    const videoElement = videoRef2.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen3 = (index) => {
    const videoElement = videoRef3.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen4 = (index) => {
    const videoElement = videoRef4.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen5 = (index) => {
    const videoElement = videoRef5.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };


  useEffect(() => {
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp")

      if (role === 'admin') {
        axios
          .get(configData.SERVER_URL + "zone/videoList",
            {
              headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
              },
            }
          )
          .then((response) => {
            setTempTableSuggestedMainVideo_playertag(response.data.data.suggested)
            if (role === "admin") {
              setTempTableSuggestedSubVideo_playertag(response.data.data.myvideos)
            }

          })
          .catch((error) => { });
      }
    }

  }, [])


  const onTabChangeVideo = (key, name) => {
    setActiveKeyVideoTab(key);
    setActiveKeyVideoTabName(name)
    resetModalVideo_playertag_tabChange()
  };



  function resetModalVideo_playertag() {
    setTempTableUploadVideo_playertag([])

    setTempTableLinkVideo_playertag([])
    setModalVideoLinkInput('')
    setModalVideoLinkInputError(false)
    setModalVideoLinkInputLoader(false)
    setModalVideoLinkInputErrorMsg("")

    setTempTableSuggestedMainVideoChecked_playertag([])
    setTempTableSuggestedSubVideoChecked_playertag([])

    setIsModalVisibleVideo(false)
    setActiveKeyVideoTab('1');
    setActiveKeyVideoTabName('Suggested');

  }

  function resetModalVideo_playertag_tabChange() {
    setTempTableUploadVideo_playertag([])

    setTempTableLinkVideo_playertag([])
    setModalVideoLinkInput('')
    setModalVideoLinkInputError(false)
    setModalVideoLinkInputLoader(false)
    setModalVideoLinkInputErrorMsg("")

    setTempTableSuggestedMainVideoChecked_playertag([])
    setTempTableSuggestedSubVideoChecked_playertag([])

  }

  // const validateVideoUrl = async () => {
  //   // Basic URL format validation
  //   const urlPattern = /^(http|https):\/\/[^ "]+$/;
  //   if (!urlPattern.test(modalVideoLinkInput)) {
  //     // setIsValid(false);
  //     // notifyfailure("Provided url is not a video")

  //     setModalVideoLinkInputErrorMsg("Provided url is not a video")
  //     setModalVideoLinkInputError(true)
  //     return;
  //   }

  //   // Fetch request to check if the URL responds with a valid video MIME type
  //   try {
  //     const response = await fetch(modalVideoLinkInput, { method: 'HEAD' });
  //     const contentType = response.headers.get('content-type');
  //     if (contentType && contentType.includes('video')) {
  //       let temp = [...tempTableLinkVideo_playertag]
  //       temp.push({
  //         "aniViewVideoId": "",
  //         "url": modalVideoLinkInput
  //       })

  //       setTempTableLinkVideo_playertag(temp)
  //       setModalVideoLinkInput("")


  //     } else {
  //       // notifyfailure("Provided url is not a video")

  //       setModalVideoLinkInputErrorMsg("Provided url is not a video")
  //       setModalVideoLinkInputError(true)
  //     }
  //   } catch (error) {
  //     // notifyfailure("Unable to fetch video from the url / CORS error")

  //     setModalVideoLinkInputErrorMsg("Unable to fetch video from the url / CORS error")
  //     setModalVideoLinkInputError(true)
  //   }
  // };

  const validateVideoUrl = async () => {
    // Basic URL format validation
    const urlPattern = /^(http|https):\/\/[^ "]+$/;
    if (!urlPattern.test(modalVideoLinkInput)) {
      // setIsValid(false);
      // notifyfailure("Provided url is not a video")

      setModalVideoLinkInputErrorMsg("Provided url is not a video")
      setModalVideoLinkInputError(true)
      return;
    }


    setModalVideoLinkInputLoader(true)
    axios
      .post(configData.SERVER_URL + "zone/getContentType", { url: modalVideoLinkInput })
      .then((response) => {
        if (response.data.videoCheck) {

          let temp = [...tempTableLinkVideo_playertag]
          temp.push({
            "aniViewVideoId": "",
            "url": modalVideoLinkInput
          })

          setTempTableLinkVideo_playertag(temp)
          setModalVideoLinkInput("")
          setModalVideoLinkInputLoader(false)
        }
        else {

          setModalVideoLinkInputErrorMsg("Unable to fetch video from the url")
          setModalVideoLinkInputError(true)
          setModalVideoLinkInputLoader(false)
        }


      })
      .catch((error) => {

        setModalVideoLinkInputErrorMsg("Unable to fetch video from the url")
        setModalVideoLinkInputError(true)
        setModalVideoLinkInputLoader(false)

      });

  };




  const items_notAdmin_playertag = [
    {
      key: '1',
      tab: 'Suggested',
      content: (
        <>
          <div className="after_upload_videos_scroll_d2 suggested">
            <Row gutter={16}>

              {tempTableSuggestedMainVideo_playertag.map((video, index) => (
                <Col span={6}>
                  <div
                    className={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1 ? 'item_selectbox primary_checkbox checked' : 'item_selectbox primary_checkbox'}
                  >
                    <div className='item_selectbox--video'>
                      <video
                        ref={el => videoRef1.current[index] = el}
                        width="600"
                        controls={false}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        muted
                      >
                        <source src={video.url} />
                        Your browser does not support the video tag.
                      </video>
                      <img src={playIcon} alt='USP' className='play_icon' />
                      <button onClick={() => { handleFullscreen1(index) }} className='expand_icon'><img src={zoomIcon} alt='USP' /></button>
                      {/* <span className='item_selectbox--video-size'>4.34 MB</span> */}
                    </div>
                    <Checkbox className='item_selectbox--checkbox'
                      checked={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1}

                      onClick={() => {
                        let tempVideo = [...tempTableSuggestedMainVideoChecked_playertag]
                        const index = tempVideo.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId);
                        if (index === -1) {
                          tempVideo.push(video);
                        } else {
                          tempVideo.splice(index, 1);
                        }

                        setTempTableSuggestedMainVideoChecked_playertag(tempVideo)
                      }}
                    ><span className='form_label'>{video.url.substring(video.url.lastIndexOf('/') + 1)}</span></Checkbox>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </>
      )
    },
    {
      key: '2', tab: 'Upload',
      content: (
        <>
          <div className="form_content_block--group upload_modal">
            <label for='file001'
              // className={dragging ? 'ant_upload_drag border_none drag_css_color' : 'ant_upload_drag border_none'}
              className={tempTableUploadVideo_playertag.length > 0 ? 'ant_upload_drag ' : 'ant_upload_drag border_none'}

            >
              <p className="upload_drag_icon">
                <img src={uploadIcon} alt='USP' />
              </p>
              <p className="ant_upload_text"><b className="primary">Click to upload</b> the video</p>
              <p className="ant_upload_hint">
                Video (max. 100 MB)
              </p>
            </label>
            <input className='form_upload d-none' type="file"
              name="file001"
              id="file001"
              accept="video/*"
              multiple
              onChange={onChangeMediakit}
            />

            <div className="after_upload_videos_scroll_d2">
              {tempTableUploadVideo_playertag.length > 0 &&
                <>      {tempTableUploadVideo_playertag.map((video, index) => (
                  <div class="ant_upload_list--item">
                    <div class="ant_upload_list--content gap_12">
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen2(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef2.current[index] = el}
                          width="138"
                          height="79"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          className='video_thumb'
                          muted
                        >
                          <source src={video.url} />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div class="ant_upload_list--info">
                        <span class="ant_upload_list--info-name">{video.filename}</span>
                        <span class="ant_upload_list--info-size">{video.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB`}</span>
                      </div>
                    </div>
                    <button type="link" class="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableUploadVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableUploadVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>}
            </div>

          </div>

        </>
      )
    },
    {
      key: '3', tab: 'Link', content: (
        <>
          <div className="form_content_block--group mt_65 mb_40">
            <div className="w_70 d_flex m-auto justify-content-center">
              <Input
                className='form_control basic pe-4'
                placeholder="Paste URL of Image"
                value={modalVideoLinkInput}
                onChange={(e) => { setModalVideoLinkInputError(false); setModalVideoLinkInputErrorMsg(""); setModalVideoLinkInput(e.target.value) }}
              />
              {modalVideoLinkInputLoader ?
                <button
                  className="btn btn_primary mt-0 ms-3 w_fit_content loader"

                >
                  <span>Submit</span>

                  <img
                    src={loaderIcon}
                    alt="USP"
                    className="loader_icon"
                  />
                </button>
                :
                <button type="submit" className='btn btn_primary mt-0 ms-3 w_fit_content'
                  disabled={modalVideoLinkInput.trim().length === 0}
                  onClick={validateVideoUrl}
                >Submit</button>
              }
            </div>
            <div className="w_70 ms-4">
              <span className="error_content ms-2">
                {modalVideoLinkInputError && (
                  <> {modalVideoLinkInputErrorMsg}</>
                )}
              </span>
            </div>

          </div>

          <div className="after_upload_videos_scroll_d2 link">
            <div className="form_content_block--group">
              {tempTableLinkVideo_playertag.length > 0 &&
                <>      {tempTableLinkVideo_playertag.map((video, index) => (
                  <div class="ant_upload_list--item">
                    <div class="ant_upload_list--content gap_12">
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen3(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef3.current[index] = el}
                          width="138"
                          height="79"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          className='video_thumb'
                          muted
                        >
                          <source src={video?.url} />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div class="ant_upload_list--info">
                        <span class="ant_upload_list--info-name">{video?.url?.includes("http") ? video?.url?.substring(video?.url?.lastIndexOf('/') + 1) : video?.url}</span>
                        {/* <span class="ant_upload_list--info-size">4 MB | 12:56</span> */}
                      </div>
                    </div>
                    <button type="link" class="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableLinkVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableLinkVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>}

            </div>
          </div>
        </>)
    },
  ];

  const items_admin_playertag = [
    {
      key: '1',
      tab: 'Suggested',
      content: (
        <>
          <div className="after_upload_videos_scroll_d2 suggested">
            <Row gutter={16}>

              {/* {tempTableSuggestedMainVideo_playertag.filter(
              video2 => !mainTableVideo_playertag.some(video1 => video1.aniViewVideoId === video2.aniViewVideoId)
            ).map((video, index) => ( */}
              {tempTableSuggestedMainVideo_playertag.map((video, index) => (
                <Col span={6}>
                  <div
                    className={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1 ? 'item_selectbox primary_checkbox checked' : 'item_selectbox primary_checkbox'}
                  >
                    <div className='item_selectbox--video'>
                      <video
                        ref={el => videoRef1.current[index] = el}
                        width="600"
                        controls={false}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        muted
                      >
                        <source src={video.url} />
                        Your browser does not support the video tag.
                      </video>
                      <img src={playIcon} alt='USP' className='play_icon' />
                      <button onClick={() => { handleFullscreen1(index) }} className='expand_icon'><img src={zoomIcon} alt='USP' /></button>
                      {/* <span className='item_selectbox--video-size'>4.34 MB</span> */}
                    </div>
                    <Checkbox className='item_selectbox--checkbox'
                      checked={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1}

                      onClick={() => {
                        let tempVideo = [...tempTableSuggestedMainVideoChecked_playertag]
                        const index = tempVideo.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId);
                        if (index === -1) {
                          tempVideo.push(video);
                        } else {
                          tempVideo.splice(index, 1);
                        }
                        setTempTableSuggestedMainVideoChecked_playertag(tempVideo)
                      }}
                    ><span className='form_label'>{video.url.substring(video.url.lastIndexOf('/') + 1)}</span></Checkbox>
                  </div>
                </Col>
              ))}

            </Row>
          </div>
        </>
      )
    },
    {
      key: '2',
      tab: 'My Video',
      content: (
        <>
          <div className="after_upload_videos_scroll_d2 suggested">
            <Row gutter={16}>

              {tempTableSuggestedSubVideo_playertag.map((video, index) => (
                <Col span={6}>
                  <div
                    className={tempTableSuggestedSubVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1 ? 'item_selectbox primary_checkbox checked' : 'item_selectbox primary_checkbox'}
                  >
                    <div className='item_selectbox--video'>
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen2(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef2.current[index] = el}
                          width="600"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          muted
                        >
                          <source src={video.url} />
                          Your browser does not support the video tag.
                        </video>

                      </div>

                      {/* <img src={playIcon} alt='USP' className='play_icon' /> */}
                      {/* <span className='item_selectbox--video-size'>4.34 MB</span> */}
                    </div>
                    <Checkbox className='item_selectbox--checkbox'
                      checked={tempTableSuggestedSubVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1}

                      onClick={() => {
                        let tempVideo = [...tempTableSuggestedSubVideoChecked_playertag]
                        const index = tempVideo.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId);
                        if (index === -1) {
                          tempVideo.push(video);
                        } else {
                          tempVideo.splice(index, 1);
                        }

                        setTempTableSuggestedSubVideoChecked_playertag(tempVideo)
                      }}
                    ><span className='form_label'>{video.url.substring(video.url.lastIndexOf('/') + 1)}</span></Checkbox>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </>
      )
    },
    {
      key: '3', tab: 'Upload',
      content: (
        <>
          <div className="form_content_block--group upload_modal">
            <label for='file001'

              // className={dragging ? 'ant_upload_drag border_none drag_css_color' : 'ant_upload_drag border_none'}
              className={tempTableUploadVideo_playertag.length > 0 ? 'ant_upload_drag ' : 'ant_upload_drag border_none'}

              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <p className="upload_drag_icon">
                <img src={uploadIcon} alt='USP' />
              </p>
              <p className="ant_upload_text"><b className="primary">Click to upload</b> the video</p>
              <p className="ant_upload_hint">
                Video (max. 100 MB)
              </p>
            </label>
            <input className='form_upload d-none' type="file"
              name="file001"
              id="file001"
              accept="video/*"
              multiple
              onChange={onChangeMediakit}
            />

            <div className="after_upload_videos_scroll_d2">
              {tempTableUploadVideo_playertag.length > 0 &&
                <>      {tempTableUploadVideo_playertag.map((video, index) => (
                  <div class="ant_upload_list--item">
                    <div class="ant_upload_list--content gap_12">
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen3(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef3.current[index] = el}
                          width="138"
                          height="79"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          className='video_thumb'
                          muted
                        >
                          <source src={video.url} />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div class="ant_upload_list--info">
                        <span class="ant_upload_list--info-name">{video.filename}</span>
                        <span class="ant_upload_list--info-size">{video.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB`}</span>
                      </div>
                    </div>
                    <button type="link" class="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableUploadVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableUploadVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>
              }
            </div>


          </div>

        </>
      )
    },
    {
      key: '4', tab: 'Link', content: (
        <>
          <div className="form_content_block--group mt_65 mb_40">
            <div className="w_70 d_flex m-auto justify-content-center">
              <Input
                className='form_control basic pe-4'
                placeholder="Paste URL of Image"
                value={modalVideoLinkInput}
                onChange={(e) => { setModalVideoLinkInputError(false); setModalVideoLinkInputErrorMsg(""); setModalVideoLinkInput(e.target.value) }}
              />
              {modalVideoLinkInputLoader ?
                <button
                  className="btn btn_primary mt-0 ms-3 w_fit_content loader"

                >
                  <span>Submit</span>

                  <img
                    src={loaderIcon}
                    alt="USP"
                    className="loader_icon"
                  />
                </button>
                :
                <button type="submit" className='btn btn_primary mt-0 ms-3 w_fit_content'
                  disabled={modalVideoLinkInput.trim().length === 0}
                  onClick={validateVideoUrl}
                >Submit</button>
              }
            </div>
            <div className="w_70 ms-4">
              <span className="error_content ms-2">
                {modalVideoLinkInputError && (
                  <> {modalVideoLinkInputErrorMsg}</>
                )}
              </span>
            </div>
          </div>

          <div className="after_upload_videos_scroll_d2 link">
            <div className="form_content_block--group">
              {tempTableLinkVideo_playertag.length > 0 &&
                <>      {tempTableLinkVideo_playertag.map((video, index) => (
                  <div class="ant_upload_list--item">
                    <div class="ant_upload_list--content gap_12">
                      <button style={{ border: "none" }} onClick={() => { handleFullscreen4(index) }} className='expand_icon'><img src={zoomIcon} alt='USP' /></button>
                      <video
                        ref={el => videoRef4.current[index] = el}
                        width="138"
                        height="79"
                        controls={false}
                        // onMouseEnter={handleMouseEnter}
                        // onMouseLeave={handleMouseLeave}
                        className='video_thumb'
                        muted
                      >
                        <source src={video?.url} />
                        Your browser does not support the video tag.
                      </video>

                      <div class="ant_upload_list--info">
                        <span class="ant_upload_list--info-name">{video?.url?.includes("http") ? video?.url?.substring(video?.url?.lastIndexOf('/') + 1) : video?.url}</span>
                        {/* <span class="ant_upload_list--info-size">4 MB | 12:56</span> */}
                      </div>
                    </div>
                    <button type="link" class="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableLinkVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableLinkVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>}

            </div>
          </div>
        </>)
    },
  ];


  ///////////////////////////////////////////////////gam tag code ///////////////////////////////////////////

  const [accountName_gamtag, setAccountName_gamtag] = useState("");
  const [accountNameIsRequiredError_gamtag, setAccountNameIsRequiredError_gamtag] =
    useState(false);
  const [platformType_gamtag, setPlatformType_gamtag] = useState("Website");
  const [ownership_gamtag, setOwnership_gamtag] = useState("Own");
  const [ownershipOptions_gamtag, setOwnershipOptions_gamtag] = useState([
    { label: "Own", value: "Own" },
    { label: "Re-seller", value: "Re-seller" },
  ]);

  const [vastVersion_gamtag, setVastVersion_gamtag] = useState("VAST 4");
  const [vastVersionOptions_gamtag, setVastVersionOptions_gamtag] = useState([
    { label: "VAST 2", value: "VAST 2" },
    { label: "VAST 3", value: "VAST 3" },
    { label: "VAST 4", value: "VAST 4" },
  ]);

  const [eCPM_gamtag, seteCPM_gamtag] = useState(0.20);
  const [eCPMOptions_gamtag, seteCPMOptions_gamtag] = useState([
    { label: "0.20", value: 0.20 },
    { label: "0.40", value: 0.40 },
    { label: "0.80", value: 0.80 },
    { label: "1.00", value: 1.00 },
    { label: "1.20", value: 1.20 }
  ]);

  function reset_gamtag() {
    setAccountName_gamtag("");
    setAccountNameIsRequiredError_gamtag(false);
    setPlatformType_gamtag("Website");
    setOwnership_gamtag("Own");
    setOwnershipOptions_gamtag([
      { label: "Own", value: "Own" },
      { label: "Re-seller", value: "Re-seller" },
    ]);
    setVastVersion_gamtag("VAST 4");
    setVastVersionOptions_gamtag([
      { label: "VAST 2", value: "VAST 2" },
      { label: "VAST 3", value: "VAST 3" },
      { label: "VAST 4", value: "VAST 4" },
    ]);
    seteCPM_gamtag(0.20);
    seteCPMOptions_gamtag([
      { label: 0.20, value: 0.20 },
      { label: 0.40, value: 0.40 },
      { label: 0.80, value: 0.80 },
      { label: 1.00, value: 1.00 },
      { label: 1.20, value: 1.20 }
    ]);
  }


  function onChangeAccountName_gamtag(event) {
    setAccountNameIsRequiredError_gamtag(false);
    setAccountName_gamtag(event.target.value);
  }

  function onBlurAccountName_gamtag(event) {
    if (event.target.value.trim().length === 0) {
      setAccountNameIsRequiredError_gamtag(true);
    }
    setAccountName_gamtag(event.target.value.trim());
  }


  function onChangePlatformType_gamtag(event) {
    setPlatformType_gamtag(event.target.value);
  }


  function onChangeOwnership_gamtag(event) {
    setOwnership_gamtag(event);
  }

  function onChangeVastVersion_gamtag(event) {
    setVastVersion_gamtag(event);
  }

  function onChangeeCPM_gamtag(event) {
    seteCPM_gamtag(event);
  }




  ///////////////////////////////////////submit //////////////////////////////////////////////////////////////////

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (formType === "Prebid") {
      if (role === "admin") {
        if (zoneName_prebid !== "" &&
          formatType_prebid.length > 0 &&
          !formatType_prebid?.includes("Banner") ? true : bannerCheckbox_prebid !== null
        ) {
          if (zoneNameIsRequiredError_prebid === false) {
            let payload =
              formatType_prebid?.includes("Banner")
                ? {
                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  bannerCheckbox: bannerCheckbox_prebid,
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                }
                : {
                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                };



            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              // setButtonValue(true);
              let token = Cookies.get("token_xapads_ssp");
              let id = jwtDecode(token)._id;

              axios
                .post(configData.SERVER_URL + `zone/createPrebidZone`, payload, {
                  headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_prebid(response.data.data)
                  setIsModalVisible(true)

                  setButtonProcessing(false)
                  // setStep(2)
                  // setTimeout(() => {
                  //   window.location.replace("/login");
                  // }, 1500);
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                  // setButtonValue(false);
                });
            }
          }
        } else {
          if (zoneName_prebid === "") {
            setZoneNameIsRequiredError_prebid(true);
          }
          if (formatType_prebid?.includes("Banner") && bannerCheckbox_prebid === null) {
            setBannerCheckboxIsRequiredError_prebid(true)
          }
          if (formatType_prebid.length === 0) {
            setFormatTypeIsRequiredError_prebid(true)
          }
        }

      }
      else {
        if (zoneName_prebid !== "" && publisherName !== ""
          &&
          formatType_prebid.length > 0 &&
          !formatType_prebid.includes("Banner") ? true : bannerCheckbox_prebid !== null
        ) {
          if (
            zoneNameIsRequiredError_prebid === false &&
            publisherIsRequiredError === false &&
            impressionValueError_prebid === false &&
            requestValueError_prebid === false
          ) {
            let payload =
              formatType_prebid.includes("Banner")
                ? {

                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  bannerCheckbox: bannerCheckbox_prebid,
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                  impressions_daily: impression_prebid !== "" ? Number(impression_prebid) : null,
                  requests_daily: request_prebid !== "" ? Number(request_prebid) : null,
                  publisherId: selectedPublisher,
                }
                : {
                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                  impressions_daily: impression_prebid !== "" ? Number(impression_prebid) : null,
                  requests_daily: request_prebid !== "" ? Number(request_prebid) : null,
                  publisherId: selectedPublisher,
                };


            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              // setButtonValue(true);
              let token = Cookies.get("token_xapads_ssp");
              let id = jwtDecode(token)._id;

              axios
                .post(configData.SERVER_URL + `zone/createPrebidZone`, payload, {
                  headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_prebid(response.data.data)
                  setIsModalVisible(true)

                  setButtonProcessing(false)
                  // setStep(2)
                  // setTimeout(() => {
                  //   window.location.replace("/login");
                  // }, 1500);
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                  // setButtonValue(false);
                });
            }
          }
        } else {
          if (zoneName_prebid === "") {
            setZoneNameIsRequiredError_prebid(true);
          }
          if (publisherName === "") {
            setPublisherIsRequiredError(true);
          }
          if (formatType_prebid.includes("Banner") && bannerCheckbox_prebid === null) {
            setBannerCheckboxIsRequiredError_prebid(true)
          }
          if (formatType_prebid.length === 0) {
            setFormatTypeIsRequiredError_prebid(true)
          }
        }
      }
    } else if (formType === "Open RTB") {
      {
        if (role === "admin") {
          if (zoneName_openrtb !== "" &&
            (platformType_openrtb === "CTV" ? true : formatType_openrtb?.length > 0) &&
            platformType_openrtb === "CTV" ? true : !formatType_openrtb?.includes("Banner") ? true : bannerCheckbox_openrtb !== null) {
            if (zoneNameIsRequiredError_openrtb === false) {
              let payload =
                formatType_openrtb?.includes("Banner")
                  ? {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    bannerCheckbox: bannerCheckbox_openrtb,
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                  }
                  : {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                  };




              setButtonProcessing(true)

              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createORTBZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_openrtb(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_openrtb === "") {
              setZoneNameIsRequiredError_openrtb(true);
            }
            if (formatType_openrtb?.includes("Banner") && bannerCheckbox_openrtb === null && platformType_openrtb !== "CTV") {
              setBannerCheckboxIsRequiredError_openrtb(true)
            }


            if (platformType_openrtb !== "CTV" && formatType_openrtb?.length === 0) {
              setFormatTypeIsRequiredError_openrtb(true)

            }

          }
        } else {
          if (zoneName_openrtb !== "" && publisherName !== "" &&
            (platformType_openrtb === "CTV" ? true : formatType_openrtb?.length > 0) &&
            platformType_openrtb === "CTV" ? true : !formatType_openrtb?.includes("Banner") ? true : bannerCheckbox_openrtb !== null) {
            if (
              zoneNameIsRequiredError_openrtb === false &&
              publisherIsRequiredError === false &&
              impressionValueError_openrtb === false &&
              requestValueError_openrtb === false
            ) {
              let payload =
                formatType_openrtb?.includes("Banner")
                  ? {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    bannerCheckbox: bannerCheckbox_openrtb,
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                    impressions_daily: impression_openrtb !== "" ? Number(impression_openrtb) : null,
                    requests_daily: request_openrtb !== "" ? Number(request_openrtb) : null,
                    publisherId: selectedPublisher
                  }
                  : {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                    impressions_daily: impression_openrtb !== "" ? Number(impression_openrtb) : null,
                    requests_daily: request_openrtb !== "" ? Number(request_openrtb) : null,
                    publisherId: selectedPublisher
                  };


              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createORTBZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_openrtb(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_openrtb === "") {
              setZoneNameIsRequiredError_openrtb(true);
            }
            if (publisherName === "") {
              setPublisherIsRequiredError(true);
            }
            if (formatType_openrtb?.includes("Banner") && bannerCheckbox_openrtb === null && platformType_openrtb !== "CTV") {
              setBannerCheckboxIsRequiredError_openrtb(true)
            }

            if (platformType_openrtb !== "CTV" && formatType_openrtb?.length === 0) {
              setFormatTypeIsRequiredError_openrtb(true)

            }
          }
        }
      }
    }
    else if (formType === "Vast Zone") {
      {
        if (role === "admin") {
          if (zoneName_vastzone !== "" &&
            (revenueType_vastzone === "Fixed_Price" ? eCpm_vastzone !== "" : true) &&
            (revenueType_vastzone === "Revshare" ? revSharePercent_vastzone !== "" : true)
          ) {
            if (
              zoneNameIsRequiredError_vastzone === false &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmValidError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentValidError_vastzone === false : true)
            ) {

              let payload =
                revenueType_vastzone === "Fixed_Price"
                  ? {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    fixed_cpm: Number(eCpm_vastzone)

                  }
                  : {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    revshare: Number(revSharePercent_vastzone)
                  };

              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createVastZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_vastzone(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_vastzone === "") {
              setZoneNameIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === "") {
              setECpmIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Revshare" && revSharePercent_vastzone === "") {
              setRevSharePercentIsRequiredError_vastzone(true);
            }
          }
        }
        else {
          if (zoneName_vastzone !== "" &&
            publisherName !== "" &&
            (revenueType_vastzone === "Fixed_Price" ? eCpm_vastzone !== "" : true) &&
            (revenueType_vastzone === "Revshare" ? revSharePercent_vastzone !== "" : true)
          ) {
            if (
              zoneNameIsRequiredError_vastzone === false &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmValidError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentValidError_vastzone === false : true)
            ) {

              let payload =
                revenueType_vastzone === "Fixed_Price"
                  ? {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    fixed_cpm: Number(eCpm_vastzone),
                    publisherId: selectedPublisher,
                    requests_daily: request_vastzone !== "" ? Number(request_vastzone) : null,
                    impressions_daily: impression_vastzone !== "" ? Number(impression_vastzone) : null

                  }
                  : {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    revshare: Number(revSharePercent_vastzone),
                    publisherId: selectedPublisher,
                    requests_daily: request_vastzone !== "" ? Number(request_vastzone) : null,
                    impressions_daily: impression_vastzone !== "" ? Number(impression_vastzone) : null
                  };

              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createVastZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_vastzone(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_vastzone === "") {
              setZoneNameIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === "") {
              setECpmIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Revshare" && revSharePercent_vastzone === "") {
              setRevSharePercentIsRequiredError_vastzone(true);
            }
            if (publisherName === "") {
              setPublisherIsRequiredError(true);
            }
          }
        }


      }
    }
    else if (formType === "vast_aniview") {
      if (role === "admin") {
        if (channelName_vast_aniview !== "" &&
          eCpm_vast_aniview !== ""
        ) {
          if (
            channelNameIsRequiredError_vast_aniview === false &&
            eCpmIsRequiredError_vast_aniview === false &&
            eCpmValidError_vast_aniview === false
          ) {

            let payload = {
              formType: formType,
              environment: platformType_vast_aniview,
              channelName: channelName_vast_aniview,
              fixed_ecpm: Number(eCpm_vast_aniview),

            }



            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");
              axios
                .post(configData.SERVER_URL + `zone/createVastZoneAniview`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_vast_aniview(response.data.data)
                  setIsModalVisible(true)
                  setButtonProcessing(false)
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                });
            }
          }
        } else {
          if (channelName_vast_aniview === "") {
            setChannelNameIsRequiredError_vast_aniview(true);
          }
          if (eCpm_vast_aniview === "") {
            setECpmIsRequiredError_vast_aniview(true);
          }
        }
      }
      else {
        if (channelName_vast_aniview !== "" &&
          publisherName !== "" &&
          eCpm_vast_aniview !== ""
        ) {
          if (
            channelNameIsRequiredError_vast_aniview === false &&
            eCpmIsRequiredError_vast_aniview === false &&
            eCpmValidError_vast_aniview === false
          ) {

            let payload = {
              formType: formType,
              environment: platformType_vast_aniview,
              channelName: channelName_vast_aniview,
              fixed_ecpm: Number(eCpm_vast_aniview),
              publisherId: selectedPublisher
            }


            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");
              axios
                .post(configData.SERVER_URL + `zone/createVastZoneAniview`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_vast_aniview(response.data.data)
                  setIsModalVisible(true)
                  setButtonProcessing(false)
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                });
            }
          }
        } else {
          if (channelName_vast_aniview === "") {
            setChannelNameIsRequiredError_vast_aniview(true);
          }
          if (eCpm_vast_aniview === "") {
            setECpmIsRequiredError_vast_aniview(true);
          }
          if (publisherName === "") {
            setPublisherIsRequiredError(true);
          }

        }
      }
    }
    else if (formType === "Player Tag" || formType === "tag_outstream") {
      {
        if (role === "admin") {
          if (channelName_playertag !== "" &&
            eCpm_playertag !== "" &&
            mainTableVideo_playertag.length > 0
          ) {
            if (
              channelNameIsRequiredError_playertag === false &&
              eCpmIsRequiredError_playertag === false &&
              eCpmValidError_playertag === false
            ) {
              let formData = new FormData();

              formData.append("formType", formType);
              formData.append("environment", platformType_playertag);
              formData.append("playerMode", playerMode_playertag);
              formData.append("channelName", channelName_playertag);
              formData.append("fixed_ecpm", Number(eCpm_playertag));
              // if (playerMode_playertag === "bannerVideo") {
              formData.append("floatingPos", floatingPosition_playertag);
              // }

              let arrayWithSize = [];
              let arrayWithoutSize = [];

              mainTableVideo_playertag.forEach(obj => {
                if (obj.hasOwnProperty('size')) {
                  arrayWithSize.push(obj);
                } else {
                  arrayWithoutSize.push(obj);
                }
              });

              formData.append("video_links", JSON.stringify(arrayWithoutSize));
              arrayWithSize.forEach((file) => {
                formData.append('video_files', file.data);
              });


              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createAniviewZone`, formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_playertag(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (channelName_playertag === "") {
              setChannelNameIsRequiredError_playertag(true);
            }
            if (eCpm_playertag === "") {
              setECpmIsRequiredError_playertag(true);
            }
            if (mainTableVideo_playertag.length === 0) {
              notifyfailure("At least 1 video is required")
            }
          }
        }
        else {
          if (channelName_playertag !== "" &&
            publisherName !== "" &&
            eCpm_playertag !== "" &&
            mainTableVideo_playertag.length > 0
          ) {
            if (
              channelNameIsRequiredError_playertag === false &&
              eCpmIsRequiredError_playertag === false &&
              eCpmValidError_playertag === false
            ) {
              let formData = new FormData();
              formData.append("formType", formType);
              formData.append("environment", platformType_playertag);
              formData.append("playerMode", playerMode_playertag);
              formData.append("channelName", channelName_playertag);
              formData.append("fixed_ecpm", Number(eCpm_playertag));
              // if (playerMode_playertag === "bannerVideo") {
              formData.append("floatingPos", floatingPosition_playertag);
              // }
              formData.append("publisherId", selectedPublisher);


              let arrayWithSize = [];
              let arrayWithoutSize = [];

              mainTableVideo_playertag.forEach(obj => {
                if (obj.hasOwnProperty('size')) {
                  arrayWithSize.push(obj);
                } else {
                  arrayWithoutSize.push(obj);
                }
              });

              formData.append("video_links", JSON.stringify(arrayWithoutSize));
              arrayWithSize.forEach((file) => {
                formData.append('video_files', file.data);
              });


              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createAniviewZone`, formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_playertag(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (channelName_playertag === "") {
              setChannelNameIsRequiredError_playertag(true);
            }
            if (eCpm_playertag === "") {
              setECpmIsRequiredError_playertag(true);
            }
            if (publisherName === "") {
              setPublisherIsRequiredError(true);
            }
            if (mainTableVideo_playertag.length === 0) {
              notifyfailure("At least 1 video is required")
            }

          }
        }

      }
    }
    else if (formType === "GAM Tag") {
      {
        if (role === "admin") {
          if (accountName_gamtag !== ""
          ) {
            if (
              accountNameIsRequiredError_gamtag === false
            ) {

              let payload = {
                formType: formType,
                accountName: accountName_gamtag,
                invent_type: platformType_gamtag,
                inventory_type: "Video",
                fixed_cpm: eCPM_gamtag,
                vastVersion: vastVersion_gamtag,
                ownership: ownership_gamtag
              };

              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createGAMZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_gamtag(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setDataModal_gamtag(response.data.data)
                    // setIsModalVisible(true)
                    // setButtonProcessing(false)
                    // window.location.reload();

                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (accountName_gamtag === "") {
              setAccountNameIsRequiredError_gamtag(true);
            }
          }
        }
        else {

          if (accountName_gamtag !== "" &&
            publisherName !== ""
          ) {
            if (
              accountNameIsRequiredError_gamtag === false
            ) {

              let payload = {
                formType: formType,
                accountName: accountName_gamtag,
                invent_type: platformType_gamtag,
                inventory_type: "Video",
                fixed_cpm: eCPM_gamtag,
                vastVersion: vastVersion_gamtag,
                ownership: ownership_gamtag,
                publisherId: selectedPublisher,
              };


              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createGAMZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {

                    notifysuccess(response.data.message);
                    setDataModal_gamtag(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setDataModal_gamtag(response.data.data)
                    // setIsModalVisible(true)
                    // setButtonProcessing(false)
                    // window.location.reload();

                  })
                  .catch((error) => {

                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (accountName_gamtag === "") {
              setAccountNameIsRequiredError_gamtag(true);
            }
            if (publisherName === "") {
              setPublisherIsRequiredError(true);
            }
          }
        }
      }
    }
  };


  // //////////////////////////////////////////////////Modal related States///////////////////////////////

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeKey, setActiveKey] = useState('1');
  const onTabChange = (key) => {
    setActiveKey(key);
  };
  const [dataModal_prebid, setDataModal_prebid] = useState({
    "hostInfo": [],
    "userSyncTag": []
  });
  const [dataModal_openrtb, setDataModal_openrtb] = useState({
    "urlTemplate": [],
    "userSyncTag": []
  });
  const [dataModal_vastzone, setDataModal_vastzone] = useState({
    "userSyncTag": []
  });

  const [dataModal_vast_aniview, setDataModal_vast_aniview] = useState({
    "userSyncTag": []
  });

  const [dataModal_playertag, setDataModal_playertag] = useState({
    "userSyncTag": []
  });

  const [dataModal_gamtag, setDataModal_gamtag] = useState({
    "userSyncTag": []
  });


  const [tooltipContent, setTooltipContent] = useState("Click to copy")

  function copyToClipboard(text) {
    // Check if the Clipboard API is supported
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Use Clipboard API to copy text to clipboard
      navigator.clipboard.writeText(text)
        .then(() => {
          // console.log("Text copied to clipboard successfully: " + text);
        })
        .catch((error) => {
          // console.error("Unable to copy text to clipboard: ", error);
        });
    } else {
      // Fallback method if Clipboard API is not supported
      var tempInput = document.createElement("input");
      tempInput.setAttribute("value", text);
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      // console.log("Text copied to clipboard successfully (fallback method): " + text);
    }

    setTooltipContent("Copied");

    setTimeout(() => {
      setTooltipContent("Click to copy");
    }, 1000);

  }



  const items_prebid = [
    {
      key: '1', tab: 'User Sync Tag',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Iframe</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => { copyToClipboard(Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[0].value : "" : "") }}
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[0].value : "" : ""}
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Image</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[1].value : "" : ""}
            </div>
          </div>

          <div className='adding_new_parameters'>
            <div className='d-flex align-items-start justify-content-between'>
              <label className='form_label'>Parameters</label>

            </div>
          </div>
          <div className='all_parameters--text'>
            <ul className='m-0 p-0'>
              <li>
                <h4 className='parameters_heading'>SSP_REDIR_URL</h4>
                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr</h4>
                <span className='parameters_text'>specifies if GDPR applies for current user (0 or 1).</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr_consent</h4>
                <span className='parameters_text'>URL-encoded Base64-encoded consent string as per IAB specification.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>us_privacy</h4>
                <span className='parameters_text'>URL-encoded U.S. Privacy string.</span>
              </li>
            </ul>
          </div>
        </>
      )
    },
    {
      key: '2', tab: 'Prebid Details', content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Zone Id</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[0].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="dark text">
              {Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[0].value : "" : ""}
            </div>
          </div>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Host name</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="dark text">
              {Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[1].value : "" : ""}
            </div>
          </div>

        </>
      )
    },
  ];


  const items_openrtb = [
    {
      key: '1',
      tab: 'URL Template',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'> US East (New York)</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[0].value : "" : ""}
            </div>
          </div>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>  US West (Los Angeles)</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[1].value : "" : ""}
            </div>
          </div>


          <div className='d-flex justify-content-between'>
            <label className='form_label'> EU (Amsterdam, NL)</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[2].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[2].value : "" : ""}
            </div>
          </div>


          <div className='d-flex justify-content-between'>
            <label className='form_label'>  APAC (Singapore)</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[3].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[3].value : "" : ""}
            </div>
          </div>


        </>
      )
    },
    {
      key: '2', tab: 'User Sync Tag',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Iframe</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[0].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[0].value : "" : ""}
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Image</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[1].value : "" : ""}
            </div>
          </div>
          <div className='adding_new_parameters'>
            <div className='d-flex align-items-start justify-content-between'>
              <label className='form_label'>Parameters</label>
              <small className='info_text--d2-orange'>*All parameters should be URL-encoded</small>
            </div>
          </div>
          <div className='all_parameters--text'>
            <ul className='m-0 p-0'>
              <li>
                <h4 className='parameters_heading'>SSP_REDIR_URL</h4>
                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr</h4>
                <span className='parameters_text'>specifies if GDPR applies for current user (0 or 1).</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr_consent</h4>
                <span className='parameters_text'>URL-encoded Base64-encoded consent string as per IAB specification.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>us_privacy</h4>
                <span className='parameters_text'>URL-encoded U.S. Privacy string.</span>
              </li>
            </ul>
          </div>
        </>
      )
    },
  ];

  const items_vastzone = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Vast ADK Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_vastzone.userSyncTag) ? dataModal_vastzone.userSyncTag.length === 1 ? dataModal_vastzone.userSyncTag[0].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_vastzone.userSyncTag) ? dataModal_vastzone.userSyncTag.length === 1 ? dataModal_vastzone.userSyncTag[0].value : "" : ""}

            </div>
          </div>
          <div className='adding_new_parameters'>
            <div className='d-flex align-items-start justify-content-between'>
              <label className='form_label'>Parameters</label>
              <small className='info_text--d2-orange'>*All parameters should be URL-encoded</small>
            </div>
          </div>
          <div className='all_parameters--text'>
            <ul className='m-0 p-0'>
              <li>
                <h4 className='parameters_heading'>subid</h4>
                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>page_url</h4>
                <span className='parameters_text'>URL of the page where ads will be displayed.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>w</h4>
                <span className='parameters_text'>Video player width.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>h</h4>
                <span className='parameters_text'>Video player height.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>startdelay</h4>
                <span className='parameters_text'>Indicates the start delay in seconds for preroll, midroll, or postroll ad placement. If the start delay value is
                  greater than 0 then the position is mid-roll, and the value represents the number of seconds into the content that
                  the ad will be displayed. If the start delay time is not available, you can report the position of the ad in general terms
                  using negative numbers:
                  <br /> 0 - Pre-roll
                  <br /> -1 - Generic mid-roll
                  <br /> -2 - Generic Post-roll</span>
              </li>
              <li>
                <h4 className='parameters_heading'>linearity</h4>
                <span className='parameters_text'>Indicates the type of an ad impression: “linear”(default) and “overlay”.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>ip</h4>
                <span className='parameters_text'>IP address of the visitor.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>ua</h4>
                <span className='parameters_text'>User-Agent header from visitor's HTTP request.</span>
              </li>
            </ul>
          </div>
        </>
      )
    }
  ];

  const items_vast_aniview = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Vast Aniview Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_vast_aniview.userSyncTag) ? dataModal_vast_aniview.userSyncTag.length === 1 ? dataModal_vast_aniview.userSyncTag[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item" style={{ height: "auto" }}>
            <div className="primary text">
              {Array.isArray(dataModal_vast_aniview.userSyncTag) ? dataModal_vast_aniview.userSyncTag.length === 1 ? dataModal_vast_aniview.userSyncTag[0].value : "" : ""}
            </div>
          </div>

        </>
      )
    }
  ];

  const items_playertag = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Player Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_playertag.userSyncTag) ? dataModal_playertag.userSyncTag.length === 1 ? dataModal_playertag.userSyncTag[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item" style={{ height: "auto" }}>
            <div className="primary text">
              {Array.isArray(dataModal_playertag.userSyncTag) ? dataModal_playertag.userSyncTag.length === 1 ? dataModal_playertag.userSyncTag[0].value : "" : ""}
            </div>
          </div>

        </>
      )
    }
  ];

  const items_gamtag = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Vast Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_gamtag.userSyncTag) ? dataModal_gamtag.userSyncTag.length === 1 ? dataModal_gamtag.userSyncTag[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item" style={{ height: "auto" }}>
            <div className="primary text">
              {Array.isArray(dataModal_gamtag.userSyncTag) ? dataModal_gamtag.userSyncTag.length === 1 ? dataModal_gamtag.userSyncTag[0].value : "" : ""}
            </div>
          </div>

        </>
      )
    }
  ];




  return (
    <>


      <div className="container_box--wrapper pt_header">
        {/* <div className="container_box--wrapper-intro">
          <h1 className="heading">Zone</h1>
        </div> */}
        {/* <div className="container_box--wrapper--title d_flex justify-content-between">
          <h1 className="heading">
            Zones
          </h1>

        </div> */}
        <div className="container_box--breadcrumb">
          <ul className="container_box--breadcrumb-list">
            <li>
              <Link onClick={() => {
                handlePageViewChange("table")
                resetFormView()
              }}>
                <img src={zoneIcon} alt="USP" /> Zones
              </Link>
            </li>
            <li className="primary">Create Zone</li>
          </ul>
        </div>
        <div className="container_box--wrapper--title">
          <div className="back_btn_d2">
            <img src={backButton} className="img-fluid" alt=""
              onClick={() => {
                handlePageViewChange("table")
                resetFormView()
              }}
            />
            <h1 className="heading">
              Create Zone
            </h1>
          </div>
        </div>
        <div className="container_box--content pt_20">
          <div className="container_box--width">
            {role !== "admin" && (
              <Row gutter={16}>
                <Col span={8}>
                  <div className="container_box--label-info">
                    <label>Publisher</label>
                    <p className="sub_text">Choose publisher account.</p>
                  </div>
                </Col>

                <Col span={16}>
                  <div className="container_box--form-container">
                    <Row gutter={16}>
                      <Col span={24}>
                        <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                          <label className="form_label">Publisher * </label>
                          <Select
                            showSearch
                            optionFilterProp="label"
                            className={
                              publisherIsRequiredError
                                ? "form_select basic error"
                                : "form_select basic "
                            }
                            // open={true}
                            value={publisherName}
                            onChange={onChangePublisher}
                            options={publisherList}
                          />
                        </div>
                        <span className="error_content">
                          {publisherIsRequiredError && (
                            <> This field is required</>
                          )}
                        </span>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            )}

            <Row gutter={16}>
              <Col span={8}>
                <div className="container_box--label-info">
                  <label>Zone Type</label>
                  <p className="sub_text">Choose your zone type.</p>
                </div>
              </Col>

              <Col span={16}>
                <div className="container_box--form-container">
                  <Row gutter={16}>
                    <Col span={24}>
                      <div className="form_content_block--group mb_0">
                        <label className="form_label">Zone Type * </label>
                        <Select
                          showSearch={false}
                          optionFilterProp="label"
                          className="form_select basic no_search"
                          // open={true}
                          value={formType}
                          onChange={onChangeFormType}
                          options={formTypeOption}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {formType === "Prebid" ? (
              <>
                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>General details</label>
                      <p className="sub_text">Please enter zone details</p>
                    </div>
                  </Col>

                  <Col span={16}>
                    <div className={role === "admin" ? "container_box--form-container mb-0" : "container_box--form-container"} >
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="form_content_block--group">
                            <label className="form_label">
                              Traffic Type *
                            </label>
                            <Radio.Group
                              onChange={onChangePlatformType_prebid}
                              value={platformType_prebid}
                              className="form_radio equal_space"
                            >
                              <Radio className="radio_btn" value="Website">
                                Website
                              </Radio>
                              <Radio className="radio_btn" value="Inapp">
                                Inapp
                              </Radio>
                            </Radio.Group>
                          </div>
                          <div className="form_content_block--group">
                            <label className="form_label">Format Type *</label>
                            {/* <Select
                              optionFilterProp="label"
                              className="form_select basic no_search"
                              value={formatType_prebid}
                              onChange={onChangeFormatType_prebid}
                              options={formatTypeOptions_prebid}
                            /> */}
                            <div className='new_cls_for_checkboxgroup_d2'>
                              <Checkbox.Group className="form_checkbox equal_space" value={formatType_prebid} onChange={onChangeFormatType_prebid}>
                                <Checkbox className="checkbox_btn" value="Banner">
                                  Banner
                                </Checkbox>
                                <Checkbox className="checkbox_btn" value="Video">
                                  Video
                                </Checkbox>
                                <Checkbox className="checkbox_btn" value="Native">
                                  Native
                                </Checkbox>
                              </Checkbox.Group>
                            </div>
                            <span className="error_content">{formatTypeIsRequiredError_prebid && <> Minimum 1 selection is required</>} </span>
                          </div>
                          {formatType_prebid?.includes("Banner") && (
                            <div className="form_content_block--group">
                              <label className="form_label">
                                In Banner Video Allow *
                              </label>
                              <Radio.Group
                                onChange={onChangeBannerCheckbox_prebid}
                                value={bannerCheckbox_prebid}
                                className="form_radio equal_space"
                              >
                                <Radio className="radio_btn" value={true}>
                                  Yes
                                </Radio>
                                <Radio className="radio_btn" value={false}>
                                  No
                                </Radio>
                              </Radio.Group>

                              <span className="error_content">
                                {bannerCheckboxIsRequiredError_prebid && (
                                  <> This field is required</>
                                )}
                              </span>
                            </div>
                          )}
                          <div className="hr_custom my_24"></div>
                          <div className="form_content_block--group">
                            <label className="form_label">Zone Name *</label>
                            <Input
                              className={
                                zoneNameIsRequiredError_prebid
                                  ? "form_control basic error"
                                  : "form_control basic"
                              }
                              value={zoneName_prebid}
                              onBlur={onBlurZoneName_prebid}
                              onChange={onChangeZoneName_prebid}
                              autocomplete="off"
                            />
                            <span className="error_content">
                              {zoneNameIsRequiredError_prebid && (
                                <> This field is required</>
                              )}
                            </span>
                          </div>
                          <div className="form_content_block--group">
                            <div className="primary_checkbox">
                              <Checkbox
                                id="zone_checkbox_prebid"
                                name="zone_checkbox_prebid"
                                checked={zoneActiveCheckbox_prebid}
                                onChange={onChangeZoneActiveCheckbox_prebid}
                              >
                                <span className="form_label">
                                  Is Zone Active?
                                </span>
                              </Checkbox>
                            </div>
                          </div>
                          <div className="form_content_block--group mb_0">
                            <label className="form_label">
                              Integration Type *
                            </label>
                            {/* <Select
                              optionFilterProp="label"
                              className="form_select basic no_search"
                              value={integrationType_prebid}
                              onChange={onChangeIntegrationType_prebid}
                              options={integrationTypeOptions_prebid}
                            /> */}

                            <Input
                              className="form_control basic"
                              value="OpenRTB (Both ADM and nURL)"
                              disabled
                              autocomplete="off"
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                {role !== "admin" && (
                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Limits</label>
                        <p className="sub_text">Enter your zone limits</p>
                      </div>
                    </Col>

                    <Col span={16}>
                      <div className="container_box--form-container mb_0">
                        <Row gutter={16}>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Requests per Day
                              </label>
                              <Input
                                className={
                                  requestValueError_prebid
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={request_prebid}
                                onBlur={onBlurRequest_prebid}
                                onChange={onChangeRequest_prebid}
                                autocomplete="off"
                              />
                            </div>
                            <span className="error_content">
                              {/* {requestIsRequiredError_prebid && (
              <> This field is required</>
            )} */}
                              {requestValueError_prebid && (
                                <> Value should be greater than 0</>
                              )}
                            </span>
                          </Col>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Impressions per Day
                              </label>
                              <Input
                                className={
                                  impressionValueError_prebid
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={impression_prebid}
                                onBlur={onBlurImpression_prebid}
                                onChange={onChangeImpression_prebid}
                                autocomplete="off"
                              />
                              <span className="error_content">
                                {/* {impressionIsRequiredError_prebid && (
              <> This field is required</>
            )} */}
                                {impressionValueError_prebid && (
                                  <> Value should be greater than 0</>
                                )}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                )}
              </>
            ) : formType === "Open RTB" ? (
              <>
                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>General details</label>
                      <p className="sub_text">Please enter zone details</p>
                    </div>
                  </Col>

                  <Col span={16}>
                    <div className={role === "admin" ? "container_box--form-container mb-0" : "container_box--form-container"} >
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="form_content_block--group">
                            <label className="form_label">
                              Traffic Type *
                            </label>
                            <Radio.Group
                              onChange={onChangePlatformType_openrtb}
                              value={platformType_openrtb}
                              className="form_radio equal_space"
                            >
                              <Radio className="radio_btn" value="Website">
                                Website
                              </Radio>
                              <Radio className="radio_btn" value="Inapp">
                                Inapp
                              </Radio>
                              <Radio className="radio_btn" value="CTV">
                                CTV
                              </Radio>
                            </Radio.Group>
                          </div>
                          <div className="form_content_block--group">
                            <label className="form_label">Format Type *</label>
                            {platformType_openrtb === "CTV" ?
                              // <Input
                              //   className="form_control basic"
                              //   value="Video"
                              //   autocomplete="off"
                              //   disabled
                              // />
                              <div className='new_cls_for_checkboxgroup_d2'>
                                <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                  <Checkbox className="checkbox_btn" value="Banner">
                                    Banner
                                  </Checkbox>
                                  <Checkbox className="checkbox_btn" value="Video">
                                    Video
                                  </Checkbox>
                                  <Checkbox className="checkbox_btn" value="Native">
                                    Native
                                  </Checkbox>
                                </Checkbox.Group>
                              </div>
                              :
                              <>
                                <div className='new_cls_for_checkboxgroup_d2'>
                                  <Checkbox.Group className="form_checkbox equal_space" value={formatType_openrtb} onChange={onChangeFormatType_openrtb}>
                                    <Checkbox className="checkbox_btn" value="Banner">
                                      Banner
                                    </Checkbox>
                                    <Checkbox className="checkbox_btn" value="Video">
                                      Video
                                    </Checkbox>
                                    <Checkbox className="checkbox_btn" value="Native">
                                      Native
                                    </Checkbox>
                                  </Checkbox.Group>
                                </div>
                                <span className="error_content">{formatTypeIsRequiredError_openrtb && <> Minimum 1 selection is required</>} </span>
                              </>
                            }

                          </div>
                          {formatType_openrtb?.includes("Banner") && platformType_openrtb !== "CTV" && (
                            <div className="form_content_block--group">
                              <label className="form_label">
                                In Banner Video Allow *
                              </label>
                              <Radio.Group
                                onChange={onChangeBannerCheckbox_openrtb}
                                value={bannerCheckbox_openrtb}
                                className="form_radio equal_space"
                              >
                                <Radio className="radio_btn" value={true}>
                                  Yes
                                </Radio>
                                <Radio className="radio_btn" value={false}>
                                  No
                                </Radio>
                              </Radio.Group>

                              <span className="error_content">
                                {bannerCheckboxIsRequiredError_openrtb && (
                                  <> This field is required</>
                                )}
                              </span>
                            </div>
                          )}
                          <div className="hr_custom my_24"></div>
                          <div className="form_content_block--group">
                            <label className="form_label">Zone Name *</label>
                            <Input
                              className={
                                zoneNameIsRequiredError_openrtb
                                  ? "form_control basic error"
                                  : "form_control basic"
                              }
                              value={zoneName_openrtb}
                              onBlur={onBlurZoneName_openrtb}
                              onChange={onChangeZoneName_openrtb}
                              autocomplete="off"
                            />
                            <span className="error_content">
                              {zoneNameIsRequiredError_openrtb && (
                                <> This field is required</>
                              )}
                            </span>
                          </div>
                          <div className="form_content_block--group">
                            <div className="primary_checkbox">
                              <Checkbox
                                id="zone_checkbox_openrtb"
                                name="zone_checkbox_openrtb"
                                checked={zoneActiveCheckbox_openrtb}
                                onChange={onChangeZoneActiveCheckbox_openrtb}
                              >
                                <span className="form_label">
                                  Is Zone Active?
                                </span>
                              </Checkbox>
                            </div>
                          </div>
                          <div className="form_content_block--group mb_0">
                            <label className="form_label">
                              Integration Type *
                            </label>
                            <Select
                              optionFilterProp="label"
                              className="form_select basic no_search"
                              value={integrationType_openrtb}
                              onChange={onChangeIntegrationType_openrtb}
                              options={integrationTypeOptions_openrtb}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                {role !== "admin" && (
                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Limits</label>
                        <p className="sub_text">Enter your zone limits</p>
                      </div>
                    </Col>

                    <Col span={16}>
                      <div className="container_box--form-container mb_0">
                        <Row gutter={16}>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Requests per Day
                              </label>
                              <Input
                                className={
                                  requestValueError_openrtb
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={request_openrtb}
                                onBlur={onBlurRequest_openrtb}
                                onChange={onChangeRequest_openrtb}
                                autocomplete="off"
                              />
                            </div>
                            <span className="error_content">
                              {/* {requestIsRequiredError_openrtb && (
              <> This field is required</>
              )} */}
                              {requestValueError_openrtb && (
                                <> Value should be greater than 0</>
                              )}
                            </span>
                          </Col>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Impressions per Day
                              </label>
                              <Input
                                className={
                                  impressionValueError_openrtb
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={impression_openrtb}
                                onBlur={onBlurImpression_openrtb}
                                onChange={onChangeImpression_openrtb}
                                autocomplete="off"
                              />
                              <span className="error_content">
                                {/* {impressionIsRequiredError_openrtb && (
              <> This field is required</>
              )} */}
                                {impressionValueError_openrtb && (
                                  <> Value should be greater than 0</>
                                )}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                )}
              </>
            ) :
              formType === "Vast Zone" ?
                (
                  <>
                    <Row gutter={16}>
                      <Col span={8}>
                        <div className="container_box--label-info">
                          <label>General details</label>
                          <p className="sub_text">Please enter zone details</p>
                        </div>
                      </Col>

                      <Col span={16}>
                        <div className={role === "admin" ? "container_box--form-container mb-0" : "container_box--form-container"} >
                          <Row gutter={16}>
                            <Col span={24}>
                              <div className="form_content_block--group">
                                <label className="form_label">
                                  Traffic Type *
                                </label>
                                <Radio.Group
                                  onChange={onChangePlatformType_vastzone}
                                  value={platformType_vastzone}
                                  className="form_radio equal_space"
                                >
                                  <Radio className="radio_btn" value="Website">
                                    Website
                                  </Radio>
                                  <Radio className="radio_btn" value="Inapp">
                                    Inapp
                                  </Radio>
                                  <Radio className="radio_btn" value="CTV">
                                    CTV
                                  </Radio>
                                </Radio.Group>
                              </div>
                              <div className="form_content_block--group">
                                <label className="form_label">Stream Position *</label>
                                {platformType_vastzone === "CTV" ?
                                  <Input
                                    className="form_control basic"
                                    value="Instream"
                                    autocomplete="off"
                                    disabled
                                  />
                                  :
                                  <Select
                                    optionFilterProp="label"
                                    className="form_select basic no_search"
                                    value={streamPosition_vastzone}
                                    onChange={onChangeStreamPosition_vastzone}
                                    options={streamPositionOptions_vastzone}
                                  />
                                }
                              </div>


                              <div className="form_content_block--group">
                                <label className="form_label">Zone Name *</label>
                                <Input
                                  className={
                                    zoneNameIsRequiredError_vastzone
                                      ? "form_control basic error"
                                      : "form_control basic"
                                  }
                                  value={zoneName_vastzone}
                                  onBlur={onBlurZoneName_vastzone}
                                  onChange={onChangeZoneName_vastzone}
                                  autocomplete="off"
                                />
                                <span className="error_content">
                                  {zoneNameIsRequiredError_vastzone && (
                                    <> This field is required</>
                                  )}
                                </span>
                              </div>
                              <div className="form_content_block--group">
                                <div className="primary_checkbox">
                                  <Checkbox
                                    id="zone_checkbox_vastzone"
                                    name="zone_checkbox_vastzone"
                                    checked={zoneActiveCheckbox_vastzone}
                                    onChange={onChangeZoneActiveCheckbox_vastzone}
                                  >
                                    <span className="form_label">
                                      Is Zone Active?
                                    </span>
                                  </Checkbox>
                                </div>
                              </div>
                              <Row gutter={16}>
                                <Col span={12}>
                                  <div className="form_content_block--group mb_0">
                                    <label className='form_label'>Revenue Type *</label>
                                    <Select
                                      showSearch={false}
                                      optionFilterProp="label"
                                      className='form_select basic no_search'
                                      value={revenueType_vastzone}
                                      onChange={onChangeRevenueType_vastzone}
                                      options={revenueTypeOptions_vastzone}
                                    />
                                  </div>
                                </Col>
                                {revenueType_vastzone === "Fixed_Price" ?
                                  <Col span={12}>
                                    <div className="form_content_block--group mb_0">
                                      <label className='form_label'>&nbsp;</label>
                                      <Input
                                        placeholder='Enter eCpm'
                                        className={
                                          eCpmIsRequiredError_vastzone
                                            ? "form_control basic error"
                                            : "form_control basic"
                                        }
                                        value={eCpm_vastzone}
                                        onBlur={onBlurECpm_vastzone}
                                        onChange={onChangeECpm_vastzone}
                                        autocomplete="off"
                                      />
                                      <span className="error_content">
                                        {eCpmIsRequiredError_vastzone && (
                                          <> This field is required</>
                                        )}
                                        {eCpmValidError_vastzone && (
                                          <> Value should be greater than 0 and less than 100</>
                                        )}
                                      </span>
                                    </div>
                                  </Col>
                                  :
                                  <Col span={12}>
                                    <div className="form_content_block--group mb-0">
                                      <label className='form_label'>&nbsp;</label>
                                      <Input
                                        placeholder='Enter Revshare'
                                        className={
                                          revSharePercentIsRequiredError_vastzone
                                            ? "form_control basic error form_control_with_icon_d2"
                                            : "form_control basic form_control_with_icon_d2"
                                        }
                                        value={revSharePercent_vastzone}
                                        onBlur={onBlurRevSharePercent_vastzone}
                                        onChange={onChangeRevSharePercent_vastzone}
                                        autocomplete="off"
                                        suffix={'%'}
                                      />
                                    </div>
                                    <span className="error_content">
                                      {revSharePercentIsRequiredError_vastzone && (
                                        <> This field is required</>
                                      )}
                                      {revSharePercentValidError_vastzone && (
                                        <> Value should be greater than 0 and less or equal to  80</>
                                      )}
                                    </span>
                                  </Col>
                                }

                              </Row>

                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    {role !== "admin" && (
                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info">
                            <label>Limits</label>
                            <p className="sub_text">Enter your zone limits</p>
                          </div>
                        </Col>

                        <Col span={16}>
                          <div className="container_box--form-container mb_0">
                            <Row gutter={16}>
                              <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                  <label className="form_label">
                                    Requests per Day
                                  </label>
                                  <Input
                                    className={
                                      requestValueError_vastzone
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={request_vastzone}
                                    onBlur={onBlurRequest_vastzone}
                                    onChange={onChangeRequest_vastzone}
                                    autocomplete="off"
                                  />
                                </div>
                                <span className="error_content">
                                  {/* {requestIsRequiredError_vastzone && (
              <> This field is required</>
              )} */}
                                  {requestValueError_vastzone && (
                                    <> Value should be greater than 0</>
                                  )}
                                </span>
                              </Col>
                              <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                  <label className="form_label">
                                    Impressions per Day
                                  </label>
                                  <Input
                                    className={
                                      impressionValueError_vastzone
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={impression_vastzone}
                                    onBlur={onBlurImpression_vastzone}
                                    onChange={onChangeImpression_vastzone}
                                    autocomplete="off"
                                  />
                                  <span className="error_content">
                                    {/* {impressionIsRequiredError_vastzone && (
              <> This field is required</>
              )} */}
                                    {impressionValueError_vastzone && (
                                      <> Value should be greater than 0</>
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </>
                )
                :
                formType === "vast_aniview" ?
                  <>
                    <Row gutter={16}>
                      <Col span={8}>
                        <div className="container_box--label-info">
                          <label>General details</label>
                          <p className="sub_text">Please enter zone details</p>
                        </div>
                      </Col>

                      <Col span={16}>
                        <div className="container_box--form-container">
                          <Row gutter={16}>
                            <Col span={24}>
                              <div className="form_content_block--group">
                                <label className="form_label">
                                  Traffic Type *
                                </label>
                                <Radio.Group
                                  onChange={onChangePlatformType_vast_aniview}
                                  value={platformType_vast_aniview}
                                  className="form_radio equal_space"
                                >
                                  <Radio className="radio_btn" value="Website">
                                    Website
                                  </Radio>
                                  <Radio className="radio_btn" value="Inapp">
                                    Inapp
                                  </Radio>
                                  <Radio className="radio_btn" value="CTV">
                                    CTV
                                  </Radio>
                                </Radio.Group>
                              </div>

                              <div className="form_content_block--group">
                                <label className="form_label">Channel Name *</label>
                                <Input
                                  className={
                                    channelNameIsRequiredError_vast_aniview
                                      ? "form_control basic error"
                                      : "form_control basic"
                                  }
                                  value={channelName_vast_aniview}
                                  onBlur={onBlurChannelName_vast_aniview}
                                  onChange={onChangeChannelName_vast_aniview}
                                  autocomplete="off"
                                />
                                <span className="error_content">
                                  {channelNameIsRequiredError_vast_aniview && (
                                    <> This field is required</>
                                  )}
                                </span>
                              </div>


                              <div className="form_content_block--group mb_0">
                                <label className='form_label'>eCPM *</label>
                                <Input
                                  placeholder='Enter eCpm'
                                  className={
                                    eCpmIsRequiredError_vast_aniview || eCpmValidError_vast_aniview
                                      ? "form_control basic error"
                                      : "form_control basic"
                                  }
                                  value={eCpm_vast_aniview}
                                  onBlur={onBlurECpm_vast_aniview}
                                  onChange={onChangeECpm_vast_aniview}
                                  autocomplete="off"
                                />
                                <span className="error_content">
                                  {eCpmIsRequiredError_vast_aniview && (
                                    <> This field is required</>
                                  )}
                                  {eCpmValidError_vast_aniview && (
                                    <> Value should be greater than 0 and less than 100</>
                                  )}
                                </span>
                              </div>

                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>


                  </>
                  :
                  (formType === "Player Tag" || formType === "tag_outstream") ?
                    <>
                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info">
                            <label>General details</label>
                            <p className="sub_text">Please enter zone details</p>
                          </div>
                        </Col>

                        <Col span={16}>
                          <div className="container_box--form-container">
                            <Row gutter={16}>
                              <Col span={24}>
                                <div className="form_content_block--group">
                                  <label className="form_label">
                                    Traffic Type *
                                  </label>
                                  <Radio.Group
                                    onChange={onChangePlatformType_playertag}
                                    value={platformType_playertag}
                                    className="form_radio equal_space"
                                  >
                                    <Radio className="radio_btn" value="Website">
                                      Website
                                    </Radio>
                                    <Radio className="radio_btn" value="Inapp">
                                      Inapp
                                    </Radio>
                                    {/* <Radio className="radio_btn" value="CTV">
                                    CTV
                                  </Radio> */}
                                  </Radio.Group>
                                </div>
                                <div className="form_content_block--group">
                                  <label className="form_label">Player Mode *</label>
                                  <Select
                                    optionFilterProp="label"
                                    className="form_select basic no_search"
                                    value={playerMode_playertag}
                                    onChange={onChangePlayerMode_playertag}
                                    options={playerModeOptions_playertag}
                                  />
                                </div>

                                {/* {playerMode_playertag === "bannerVideo" && */}
                                <div className="form_content_block--group">
                                  <label className="form_label">Floating Position *</label>
                                  <Select
                                    optionFilterProp="label"
                                    className="form_select basic no_search"
                                    value={floatingPosition_playertag}
                                    onChange={onChangeFloatingPosition_playertag}
                                    options={formType === "tag_outstream" ? floatingPositionOptions_tag_outstream : floatingPositionOptions_playertag}
                                  />
                                </div>
                                {/* } */}


                                <div className="form_content_block--group">
                                  <label className="form_label">Channel Name *</label>
                                  <Input
                                    className={
                                      channelNameIsRequiredError_playertag
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={channelName_playertag}
                                    onBlur={onBlurChannelName_playertag}
                                    onChange={onChangeChannelName_playertag}
                                    autocomplete="off"
                                  />
                                  <span className="error_content">
                                    {channelNameIsRequiredError_playertag && (
                                      <> This field is required</>
                                    )}
                                  </span>
                                </div>


                                <div className="form_content_block--group mb_0">
                                  <label className='form_label'>eCPM *</label>
                                  <Input
                                    placeholder='Enter eCpm'
                                    className={
                                      eCpmIsRequiredError_playertag || eCpmValidError_playertag
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={eCpm_playertag}
                                    onBlur={onBlurECpm_playertag}
                                    onChange={onChangeECpm_playertag}
                                    autocomplete="off"
                                  />
                                  <span className="error_content">
                                    {eCpmIsRequiredError_playertag && (
                                      <> This field is required</>
                                    )}
                                    {eCpmValidError_playertag && (
                                      <> Value should be greater than 0 and less than 100</>
                                    )}
                                  </span>
                                </div>

                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info"

                          >
                            <label>CMS</label>
                            <p className='sub_text'>Upload your desired video</p>
                          </div>
                        </Col>

                        <Col span={16}>
                          <div className="form_content_block--group mb_0"

                          >
                            <label
                              // for='fileUploader' 
                              className='ant_upload_drag mb-4'
                              onClick={() => { setIsModalVisibleVideo(true) }}
                            >
                              <p className="upload_drag_icon">
                                <img src={uploadIcon} alt='USP' />
                              </p>
                              <p className="ant_upload_text"><b className="primary">Click to upload</b> the video</p>
                              <p className="ant_upload_hint">
                                Video (max. 100 MB)
                              </p>
                            </label>
                            {/* <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" /> */}
                            {mainTableVideo_playertag?.length > 0 &&
                              <>
                                {mainTableVideo_playertag?.map((video, index) => (
                                  <>
                                    <div class="ant_upload_list--item">

                                      <div class="ant_upload_list--content gap_12">
                                        <div className="thumbnail_content--video position-relative">
                                          <button className='thumbnail_content--play'
                                            onClick={() => { handleFullscreen5(index) }}
                                          ><img src={playIcon} alt='USP' /></button>
                                          <video
                                            ref={el => videoRef5.current[index] = el}
                                            width="138"
                                            height="79"
                                            controls={false}
                                            className='video_thumb'
                                            // onMouseEnter={handleMouseEnter}
                                            // onMouseLeave={handleMouseLeave}
                                            muted
                                          >
                                            <source src={video.url} />
                                            Your browser does not support the video tag.
                                          </video>
                                        </div>

                                        <div class="ant_upload_list--info">
                                          <span class="ant_upload_list--info-name">{video?.url?.includes("blob") ? video?.filename : video?.url?.substring(video?.url?.lastIndexOf('/') + 1)}</span>
                                          <span class="ant_upload_list--info-size">{video?.url?.includes("blob") ? video?.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB` : ""}</span>
                                        </div>



                                      </div>
                                      <button type="link" class="download_icon download_icon_d2"
                                        onClick={() => {
                                          const newArray = [...mainTableVideo_playertag];
                                          newArray.splice(index, 1);
                                          setMainTableVideo_playertag(newArray);
                                        }}
                                      >
                                        <img src={deleteIcon} alt="USP" />
                                      </button>

                                    </div>
                                  </>

                                ))}
                              </>
                            }
                          </div>
                        </Col>
                        <Col span={16}>
                          <div className="form_content_block--group mb_0">

                            <Modal
                              centered
                              className='custom_modal custom_modal_d2'
                              title={<div className='custom_modal--header --tabs'><h3 className='heading'><img src={addVideoIcon} alt='USP' /> Add Video</h3>
                                <div className="tab_content--buttons">
                                  <>
                                    {role === "admin" ?
                                      <>
                                        {items_admin_playertag.map((item) => (
                                          <button
                                            key={item.key}
                                            onClick={() => onTabChangeVideo(item.key, item.tab)}
                                            className={activeKeyVideoTab === item.key ? 'btn active' : 'btn'}
                                          >
                                            {item.tab}
                                          </button>
                                        ))}
                                      </>
                                      :
                                      <>
                                        {items_notAdmin_playertag.map((item) => (
                                          <button
                                            key={item.key}
                                            onClick={() => onTabChangeVideo(item.key, item.tab)}
                                            className={activeKeyVideoTab === item.key ? 'btn active' : 'btn'}
                                          >
                                            {item.tab}
                                          </button>
                                        ))}

                                      </>}

                                  </>
                                </div>
                              </div>}
                              visible={isModalVisibleVideo}
                              maskClosable={false}
                              onCancel={() => { setIsModalVisibleVideo(false) }}
                              // This removes the default close button
                              width={1000}
                              footer={[
                                <div className="custom_modal--footer d_flex justify_content_end">
                                  {activeKeyVideoTabName === "Suggested" ?
                                    <>
                                      <span className='selected_items'>{tempTableSuggestedMainVideoChecked_playertag.length > 0 ? `${tempTableSuggestedMainVideoChecked_playertag.length} Selected` : ""} </span>
                                      <button key="submit" className='btn btn_primary w_fit_content'
                                        disabled={tempTableSuggestedMainVideoChecked_playertag.length === 0}
                                        onClick={() => {
                                          setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableSuggestedMainVideoChecked_playertag])
                                          resetModalVideo_playertag()
                                        }}
                                      >
                                        Upload
                                      </button>
                                    </> :
                                    activeKeyVideoTabName === "My Video" ?
                                      <>

                                        <span className='selected_items'>{tempTableSuggestedSubVideoChecked_playertag.length > 0 ? `${tempTableSuggestedSubVideoChecked_playertag.length} Selected` : ""} </span>
                                        <button key="submit" className='btn btn_primary w_fit_content'
                                          disabled={tempTableSuggestedSubVideoChecked_playertag.length === 0}
                                          onClick={() => {
                                            setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableSuggestedSubVideoChecked_playertag])
                                            resetModalVideo_playertag()
                                          }}
                                        >
                                          Upload
                                        </button>

                                      </> :
                                      activeKeyVideoTabName === "Link" ?
                                        <>
                                          <button key="submit" className='btn btn_primary w_fit_content'
                                            disabled={tempTableLinkVideo_playertag.length === 0}
                                            onClick={() => {
                                              setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableLinkVideo_playertag])
                                              resetModalVideo_playertag()
                                            }}
                                          >
                                            Upload
                                          </button>
                                        </>
                                        :
                                        activeKeyVideoTabName === "Upload" ?
                                          <>
                                            <button key="submit" className='btn btn_primary w_fit_content'
                                              disabled={tempTableUploadVideo_playertag.length === 0}
                                              onClick={() => {
                                                setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableUploadVideo_playertag])
                                                resetModalVideo_playertag()
                                              }}
                                            >
                                              Upload
                                            </button>
                                          </>
                                          :
                                          <></>
                                  }
                                </div>
                              ]}
                            >
                              <div className="custom_modal--body">
                                <div className="tab_content--body">
                                  {role === "admin" ?
                                    <>
                                      {items_admin_playertag.map((item) => (
                                        <div
                                          key={item.key}
                                          style={{ display: activeKeyVideoTab === item.key ? 'block' : 'none' }}
                                        >
                                          {item.content}
                                        </div>
                                      ))}
                                    </>
                                    :
                                    <>
                                      {items_notAdmin_playertag.map((item) => (
                                        <div
                                          key={item.key}
                                          style={{ display: activeKeyVideoTab === item.key ? 'block' : 'none' }}
                                        >
                                          {item.content}
                                        </div>
                                      ))}
                                    </>
                                  }

                                </div>
                              </div>
                            </Modal>

                          </div>
                        </Col>
                      </Row>

                    </>
                    :
                    (
                      <>
                        <Row gutter={16}>
                          <Col span={8}>
                            <div className="container_box--label-info">
                              <label>General details</label>
                              <p className="sub_text">Please enter zone details</p>
                            </div>
                          </Col>

                          <Col span={16}>
                            <div className="container_box--form-container mb_0">
                              <Row gutter={16}>
                                <Col span={24}>

                                  <div className="form_content_block--group">
                                    <label className="form_label">Account Name *</label>
                                    <Input
                                      className={
                                        accountNameIsRequiredError_gamtag
                                          ? "form_control basic error"
                                          : "form_control basic"
                                      }
                                      value={accountName_gamtag}
                                      onBlur={onBlurAccountName_gamtag}
                                      onChange={onChangeAccountName_gamtag}
                                      autocomplete="off"
                                    />
                                    <span className="error_content">
                                      {accountNameIsRequiredError_gamtag && (
                                        <> This field is required</>
                                      )}
                                    </span>
                                  </div>

                                  <div className="form_content_block--group">
                                    <label className="form_label">Inventory Type *</label>
                                    <Input
                                      className="form_control basic"
                                      value="Video"
                                      autocomplete="off"
                                      disabled
                                    />
                                    <span className="error_content">
                                    </span>
                                  </div>


                                  <div className="form_content_block--group">
                                    <label className="form_label">
                                      Traffic Type *
                                    </label>
                                    <Radio.Group
                                      onChange={onChangePlatformType_gamtag}
                                      value={platformType_gamtag}
                                      className="form_radio equal_space"
                                    >
                                      <Radio className="radio_btn" value="Website">
                                        Website
                                      </Radio>
                                      <Radio className="radio_btn" value="Inapp">
                                        Inapp
                                      </Radio>
                                      <Radio className="radio_btn" value="CTV">
                                        CTV
                                      </Radio>
                                    </Radio.Group>
                                  </div>



                                  <div className="form_content_block--group">
                                    <label className="form_label">Ownership *</label>
                                    <Select
                                      optionFilterProp="label"
                                      className="form_select basic no_search"
                                      value={ownership_gamtag}
                                      onChange={onChangeOwnership_gamtag}
                                      options={ownershipOptions_gamtag}
                                    />
                                  </div>

                                  <div className="form_content_block--group">
                                    <label className="form_label">VAST Version *</label>
                                    <Select
                                      optionFilterProp="label"
                                      className="form_select basic no_search"
                                      value={vastVersion_gamtag}
                                      onChange={onChangeVastVersion_gamtag}
                                      options={vastVersionOptions_gamtag}
                                    />
                                  </div>

                                  <div className="form_content_block--group mb_0">
                                    <label className="form_label">eCPM *</label>
                                    <Select
                                      optionFilterProp="label"
                                      className="form_select basic no_search"
                                      value={eCPM_gamtag}
                                      onChange={onChangeeCPM_gamtag}
                                      options={eCPMOptions_gamtag}
                                    />
                                  </div>


                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>

                      </>
                    )

            }

          </div>
          <div className="hr_custom mb_20"></div>
          <div className="btn_group justify-content-end gap_8 pb_50">
            {buttonProcessing ?
              <>
                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                  disabled
                >
                  Discard
                </button>
                <button
                  className="w_120_d2 btn btn_primary w_fit_content loader"

                >
                  <span>Create Zone</span>

                  <img
                    src={loaderIcon}
                    alt="USP"
                    className="loader_icon"
                  />
                </button>
              </> :
              <>
                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                  onClick={() => {
                    handlePageViewChange("table")
                    resetFormView()
                  }}
                >
                  Discard
                </button>
                <button
                  className="w_120_d2 btn btn_primary w_fit_content"
                  onClick={handleSubmit}
                >
                  Create zone
                </button>
              </>
            }

          </div>


          <Modal
            centered
            className='custom_modal'
            title={<div className='custom_modal--header --tabs'><h3 className='heading'><img src={zoneInfoIcon} alt='USP' /> Zone info</h3>
              <div className="tab_content--buttons">
                <>
                  {formType === "Open RTB" ?
                    <>
                      {items_openrtb.map((item) => (
                        <button
                          key={item.key}
                          onClick={() => onTabChange(item.key)}
                          className={activeKey === item.key ? 'btn active' : 'btn'}
                        >
                          {item.tab}
                        </button>
                      ))}
                    </>
                    :
                    formType === "Prebid" ?
                      <>
                        {items_prebid.map((item) => (
                          <button
                            key={item.key}
                            onClick={() => onTabChange(item.key)}
                            className={activeKey === item.key ? 'btn active' : 'btn'}
                          >
                            {item.tab}
                          </button>
                        ))}
                      </>
                      :
                      formType === "Vast Zone" ?
                        <>
                          {items_vastzone.map((item) => (
                            <button
                              key={item.key}
                              onClick={() => onTabChange(item.key)}
                              className={activeKey === item.key ? 'btn active' : 'btn'}
                            >
                              {item.tab}
                            </button>
                          ))}

                        </>
                        :
                        formType === "vast_aniview" ?
                          <>
                            {items_vast_aniview.map((item) => (
                              <button
                                key={item.key}
                                onClick={() => onTabChange(item.key)}
                                className={activeKey === item.key ? 'btn active' : 'btn'}
                              >
                                {item.tab}
                              </button>
                            ))}
                          </>
                          :
                          (formType === "Player Tag" || formType === "tag_outstream") ?
                            <>
                              {items_playertag.map((item) => (
                                <button
                                  key={item.key}
                                  onClick={() => onTabChange(item.key)}
                                  className={activeKey === item.key ? 'btn active' : 'btn'}
                                >
                                  {item.tab}
                                </button>
                              ))}
                            </>
                            :
                            <>
                              {items_gamtag.map((item) => (
                                <button
                                  key={item.key}
                                  onClick={() => onTabChange(item.key)}
                                  className={activeKey === item.key ? 'btn active' : 'btn'}
                                >
                                  {item.tab}
                                </button>
                              ))}
                            </>

                  }

                </>
              </div>
            </div>}
            visible={isModalVisible}
            onOk={() => { window.location.reload() }}
            closable={false} // This removes the default close button
            width={770}
            footer={[
              <div className="custom_modal--footer d_flex justify_content_end">
                <button key="submit" className='btn btn_primary w_fit_content' onClick={() => { window.location.reload() }}>
                  Ok
                </button>
              </div>
            ]}
          >
            <div className="custom_modal--body">
              <div className="tab_content--body">
                <>
                  {formType === "Open RTB" ?
                    <>
                      {items_openrtb.map((item) => (
                        <div
                          key={item.key}
                          style={{ display: activeKey === item.key ? 'block' : 'none' }}
                        >
                          {item.content}
                        </div>
                      ))}
                    </>
                    :
                    formType === "Prebid" ?
                      <>
                        {items_prebid.map((item) => (
                          <div
                            key={item.key}
                            style={{ display: activeKey === item.key ? 'block' : 'none' }}
                          >
                            {item.content}
                          </div>
                        ))}
                      </>
                      :
                      formType === "Vast Zone" ?
                        <>
                          {items_vastzone.map((item) => (
                            <div
                              key={item.key}
                              style={{ display: activeKey === item.key ? 'block' : 'none' }}
                            >
                              {item.content}
                            </div>
                          ))}
                        </>
                        :
                        formType === "vast_aniview" ?
                          <>
                            {items_vast_aniview.map((item) => (
                              <div
                                key={item.key}
                                style={{ display: activeKey === item.key ? 'block' : 'none' }}
                              >
                                {item.content}
                              </div>
                            ))}
                          </>
                          :
                          (formType === "Player Tag" || formType === "tag_outstream") ?
                            <>
                              {items_playertag.map((item) => (
                                <div
                                  key={item.key}
                                  style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                >
                                  {item.content}
                                </div>
                              ))}
                            </>
                            :
                            <>
                              {items_gamtag.map((item) => (
                                <div
                                  key={item.key}
                                  style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                >
                                  {item.content}
                                </div>
                              ))}
                            </>

                  }

                </>
              </div>
            </div>
          </Modal>
        </div>
      </div >

    </>
  );
};

export default ZoneCreate;
